import { baseTr, baseEn, type BaseMessageKey } from "@csa/web-foundation";

// Turkish-first i18n (ADR 0015 §7). These are the CONSOLE's surface strings; the
// base chrome strings (auth, principal, four-eyes, generic errors) live in
// @csa/web-foundation and are merged in below. `app.title` overrides the base
// brand-neutral default with the advisor console's product name.
export const tr = {
  "app.title": "CSA Privé — Danışman Konsolu",
  "shell.brandSub": "Danışman Konsolu",
  "shell.role": "Danışman",
  // Fable IA rail clusters (Bugün · Müşteriler · İş Akışı · Finans & Uyum · Hesap).
  "nav.section.today": "Bugün",
  "nav.section.customers": "Müşteriler",
  "nav.section.workflow": "İş Akışı",
  "nav.section.finance": "Finans & Uyum",
  "nav.section.account": "Hesap",
  "nav.today": "Günüm",
  "nav.queue": "Kuyruk",
  "nav.intake": "Yeni talep",
  "nav.recommendations": "Öneri",
  "nav.teklif": "Teklif Formu",
  "nav.households": "Müşterilerim",
  "nav.relationships": "İlişki",
  "nav.book": "Defterim",
  // İlişki kokpiti (CR-3)
  "rel.heading": "İlişki",
  "rel.subtitle": "Concierge bakım-CRM'i — ilişki sağlığı, kota değil.",
  "rel.gov": "Komisyon yok · Care-hold'da satış yok · Tek ilişki-sahibi (ADR 0014)",
  "rel.tab.lifecycle": "Yaşam döngüsü",
  "rel.tab.opportunities": "Fırsatlar",
  "rel.tab.segments": "Segmentler",
  "rel.tab.tasks": "Görevlerim",
  "rel.lc.title": "Bakım hattı",
  "rel.lc.note": "Kota değil — ilişki sağlığı. Her hane tek bir aşamada.",
  "rel.lc.prospect": "Aday",
  "rel.lc.interested": "İlgili",
  "rel.lc.customer": "Müşteri",
  "rel.lc.renewal": "Yenileme",
  "rel.lc.risk": "Risk",
  "rel.lc.empty.title": "Defterinizde hane yok",
  "rel.lc.empty.desc": "Hane geldikçe bakım hattı burada oluşur.",
  "rel.loading": "Yükleniyor…",
  "rel.error.title": "Bir şey ters gitti",
  "rel.error.detail": "Liste alınamadı.",
  "rel.retry": "Tekrar dene",
  "rel.reassure": "Verilerinizde bir değişiklik olmadı; tekrar deneyebilirsiniz.",
  "rel.opp.empty.title": "Açık fırsat yok",
  "rel.opp.empty.desc": "Defterinizde şu an değerlendirilecek açık bir fırsat bulunmuyor.",
  "rel.opp.more": "Daha fazla",
  "rel.opp.type.uninsured": "Sigortasız araç",
  "rel.opp.type.kasko": "Kasko açığı",
  "rel.opp.type.lapsed": "Yenilenmemiş",
  "rel.opp.why.uninsured": "Zorunlu trafik teminatı olmayan bir araç var",
  "rel.opp.why.kasko": "Trafik var, kasko yok — değer eşiği aşıldı",
  "rel.opp.why.lapsed": "Süresi biten poliçe henüz yenilenmedi",
  "rel.opp.daysLeft": "gün kaldı",
  "rel.opp.prepare": "Öneri hazırla",
  "rel.opp.defer": "Ertele",
  "rel.opp.defer.until": "Şu tarihe kadar ertele",
  "rel.opp.defer.confirm": "Ertele",
  "rel.opp.defer.cancel": "Vazgeç",
  "rel.tab.suppressed": "Bastırılanlar",
  "rel.sup.intro":
    "Motorun geri tuttuğu temaslar ve nedeni. Görev-of-care temasları hiçbir zaman bastırılmaz.",
  "rel.sup.noConsent": "Açık rıza yok",
  "rel.sup.careHold": "Care-hold",
  "rel.sup.coolOff": "Bekleme süresi",
  "rel.sup.touchCap": "Temas sınırı",
  "rel.sup.other": "Bastırıldı",
  "rel.sup.empty.title": "Bastırılan temas yok",
  "rel.sup.empty.desc": "Defterinizde şu an geri tutulan bir temas bulunmuyor.",
  "rel.seg.system.title": "Sistem segmentleri",
  "rel.seg.saved.title": "Kayıtlı segmentler",
  "rel.seg.empty": "Henüz kayıtlı segment yok.",
  "rel.seg.count": "hane",
  "rel.seg.households.title": "Haneler",
  "rel.seg.households.empty": "Bu segmentte defterinizden hane yok.",
  "rel.seg.households.capped": "hane gösteriliyor — liste bir önizlemedir, tamamı değil.",
  "rel.seg.pick": "Ayrıntı için soldan bir segment seçin.",
  "rel.task.new.placeholder": "Yeni görev (ör. Ayşe'yi yenileme için ara)",
  "rel.task.new.note": "Not (opsiyonel)",
  "rel.task.add": "Ekle",
  "rel.task.adding": "Ekleniyor…",
  "rel.task.empty.title": "Görev yok",
  "rel.task.empty.desc": "Kişisel takip görevleriniz burada görünür.",
  "rel.task.done": "Tamamla",
  "rel.task.dismiss": "Vazgeç",
  "rel.task.status.open": "Açık",
  "rel.task.status.done": "Tamamlandı",
  "rel.task.status.dismissed": "Vazgeçildi",
  "nav.claims": "Hasarlar",
  "nav.issuance": "İhraç",
  "nav.renewals": "Yenilemeler",
  "nav.reconciliation": "Mutabakat",
  "nav.reports": "Raporlar",
  "nav.approvals": "Onaylar",
  "nav.notifications": "Bildirimler",
  "nav.settings": "Hesap & ayarlar",
  // ⌘K global search + quiet notification dot + role affordances.
  "shell.search.open": "Ara (⌘K)",
  "shell.search.placeholder": "Ara…",
  "shell.search.customers": "Müşteri, poliçe veya sayfa ara…",
  "shell.search.hint": "Bir sayfaya atlayın ya da Enter ile müşterilerde arayın.",
  "shell.search.empty": "Eşleşen sayfa yok. Enter ile müşterilerde arayın.",
  "shell.search.close": "Kapat",
  "shell.notifications.pending": "Bildirimler — bekleyen bir öğe var",
  "shell.notifications.unread": "Bildirimler — okunmamış",
  "shell.notifications.idle": "Bildirimler — bekleyen öğe yok",
  "shell.scope.team": "Ekip görünümü",
  "shell.admin.oversight":
    "Tüm organizasyon görünümü — yönetici. Erişimleriniz denetim kaydına işlenir. Yetki görünürlüktür, kontrol değil: fiyat-dışı ihraç ve yapılandırma değişiklikleri dört-göz kalır.",
  "shell.admin.consoleLink": "Admin Console'a git",
  "placeholder.preparing": "Hazırlanıyor — bu yüzey sonraki dilimde geliyor.",
  "queue.heading": "Günlük Kuyruk",
  "queue.loading": "Kuyruk yükleniyor…",
  "queue.empty": "Bekleyen iş yok. Kuyruk temiz.",
  "queue.error": "Kuyruk yüklenemedi.",
  "queue.filter.allBands": "Tüm öncelikler",
  "queue.filter.allTypes": "Tüm türler",
  "queue.touch": "müşteri teması",
  "queue.itemsInBundle": "iş bu temada",
  "queue.due": "Termin",
  "queue.sla": "SLA",
  "queue.suggestion": "Öneri",
  "queue.claim": "Üstlen",
  "queue.complete": "Tamamla",
  "queue.dismiss": "Kapat",
  "queue.disposition_prompt": "Tamamlama notu (sonuç):",
  "queue.reason_prompt": "Kapatma gerekçesi:",
  "queue.inProgress": "Üzerinde çalışılıyor",
  "queue.status.PENDING": "Bekliyor",
  "queue.status.IN_PROGRESS": "Üzerinde çalışılıyor",
  "queue.status.DONE": "Tamamlandı",
  "queue.status.DISMISSED": "Vazgeçildi",
  "queue.status.SUPPRESSED": "Bastırıldı",
  "queue.prepareOffers": "3 Teklif Hazırla",
  "band.HIGH": "Yüksek",
  "band.MEDIUM": "Orta",
  "band.LOW": "Düşük",
  "item.RENEWAL": "Yenileme zamanı",
  "item.OPPORTUNITY": "Çapraz satış fırsatı",
  "item.ALERT": "Servis uyarısı",
  "item.SERVICE_FOLLOWUP": "Servis takibi",
  "item.NEW_LEAD": "Yeni aday",
  // Inbound-intake leads now land in the queue as NEW_LEAD items — a source-accurate
  // badge (Web / Telefon) + the intake-captured plate label render inline on the row.
  "leads.source.web": "Web",
  "leads.source.phone": "Telefon",
  "leads.plate": "Plaka",
  // PREPARE-OFFERS — bir web lead'i kuyruktan açıp 1–3 teklif hazırla (paket + prim),
  // sunucu puanlı bir DRAFT öneri döndürür; danışman mevcut seç→tier2→sun akışını sürdürür.
  "po.heading": "3 Teklif Hazırla",
  "po.subheading":
    "Bu web lead'i için 1–3 teklif girin. Kaydedince puanlı bir öneri oluşur ve mevcut öneri akışıyla devam edersiniz.",
  "po.line": "Branş",
  "po.line.trafik": "Zorunlu Trafik",
  "po.line.kasko": "Kasko",
  "po.line.dask": "DASK (Zorunlu Deprem)",
  "po.line.konut": "Konut",
  "po.line.tss": "Tamamlayıcı Sağlık (TSS)",
  "po.line.oss": "Özel Sağlık (OSS)",
  "po.line.seyahat": "Seyahat",
  // Hâlâ serbest-metin paket kodu kullanan yüzeyler için (ör. Teklif Formu).
  "po.catalogFlag":
    "Not: Bu yüzeyde paket kodu elle girilir (küçük harf-kebap, ör. ak-trafik-standart). Sigortacı, koddan sunucuda çözülür.",
  // Paket seçici (PackagePicker) — GET /v1/catalog/packages?line= listesinden
  // "Sigortacı — Paket" seçenekleri; liste boş/hatalıysa serbest metne düşer.
  "po.pkg.loading": "Paketler yükleniyor…",
  "po.pkg.placeholder": "Paket seçin…",
  "po.pkg.emptyFallback":
    "Bu branş için dağıtıma açık paket bulunamadı — paket kodunu elle girin (ör. ak-trafik-standart).",
  "po.pkg.errorFallback":
    "Paket listesi yüklenemedi — paket kodunu elle girebilirsiniz. Yetki/branş kontrolü sunucuda yapılır.",
  // MÜŞTERİ BAĞLAMI — ad + plaka + telefon lead-bağlam okumasından
  // (GET /v1/leads/:id/context); okuma başarısızsa ad/plaka kuyruk bağlamına düşer.
  "po.contextUnknownName": "İsim taşınmadı",
  "po.packageCode": "Paket kodu",
  "po.packagePlaceholder": "ör. ak-trafik-standart",
  "po.packageHint":
    "Paket kodu sigortacıyı belirler (Sigortacı — Paket). Yetki/branş kontrolü sunucuda yapılır.",
  "po.premium": "Prim (TRY)",
  "po.premiumInvalid": "Prim negatif olmayan bir ondalık olmalı (en çok 2 basamak).",
  "po.addOffer": "Teklif ekle",
  "po.removeOffer": "Kaldır",
  "po.submit": "Teklifleri hazırla ve puanla",
  "po.submitting": "Hazırlanıyor…",
  "po.needOne": "En az bir teklif (paket kodu + prim) girin.",
  "po.err.lineNeeded": "Branş belirsiz — lütfen branş (trafik/kasko) seçin.",
  "po.err.assetAmbiguous":
    "Birden fazla sigortalanabilir varlık var — bu lead tek bir varlığa bağlanamadı.",
  "po.err.noAsset": "Bu müşteri için sigortalanabilir varlık bulunamadı.",
  "po.err.unsupportedLine": "Öneri motoru yalnızca trafik/kasko destekler.",
  "po.err.notAuthorized": "Bu paket bu branşta dağıtıma yetkili değil.",
  "po.err.premium": "Prim geçersiz — negatif olmayan bir tutar girin.",
  "po.err.package": "Paket bulunamadı veya bu branşla uyuşmuyor.",
  // DEVRET — lead sahipliğini başka bir ACTIVE danışmana ata
  // (GET /v1/leads/assignable-advisors → POST /v1/leads/:id/assign { ownerStaffId }).
  "po.reassign.open": "Danışmana ata",
  "po.reassign.title": "Lead'i devret",
  "po.reassign.desc": "Bu lead'i organizasyonunuzdaki aktif bir danışmana devredin.",
  "po.reassign.advisor": "Danışman",
  "po.reassign.choose": "Danışman seçin…",
  "po.reassign.loading": "Danışmanlar yükleniyor…",
  "po.reassign.listError": "Danışman listesi yüklenemedi.",
  "po.reassign.empty": "Atanabilecek başka danışman yok.",
  "po.reassign.cancel": "Vazgeç",
  "po.reassign.confirm": "Devret",
  "po.reassign.saving": "Devrediliyor…",
  "po.reassign.success": "Yeni danışmana devredildi:",
  "po.reassign.owner": "Yeni sahip",
  // MÜŞTERİ → TEKLİF FORMU — danışman-operatörlü, konsol içi 3 adımlı sihirbaz
  // (Bilgiler → Teklifler → Danışman). Müşteri herhangi bir kanaldan geldi (öz-servis
  // web formu DEĞİL); danışman müşteriyi kaydeder ve 1–3 teklif oluşturur. Adım 1
  // telefon-kaydı yakalama zincirini, Adım 2 mevcut prepare-offers'ı yeniden kullanır.
  "qf.heading": "Müşteri → Teklif Formu",
  "qf.subheading":
    "Herhangi bir kanaldan gelen müşteriyi kaydedin ve 1–3 teklif oluşturun. Tümü sisteme işlenir; sonunda öneri akışıyla devam edersiniz.",
  "qf.restricted":
    "Bu akış için lead:write, party:write, capture:write ve recommendation:write yetkileri gerekir.",
  "qf.step1": "Bilgiler",
  "qf.step2": "Teklifler",
  "qf.step3": "Danışman",
  "qf.section.product": "Ürün ve kanal",
  "qf.line": "Branş",
  "qf.line.trafik": "Zorunlu Trafik",
  "qf.line.kasko": "Kasko",
  "qf.channel": "Nereden geldi? (kanal)",
  "qf.channel.PHONE": "Telefon",
  "qf.channel.EMAIL": "E-posta",
  "qf.channel.WHATSAPP": "WhatsApp",
  "qf.channel.IN_PERSON": "Yüz yüze",
  "qf.channelHint": "Müşterinin ulaştığı kanal etkileşim kaydına işlenir.",
  "qf.section.customer": "Müşteri bilgileri",
  "qf.firstName": "Ad",
  "qf.lastName": "Soyad",
  "qf.tckn": "T.C. Kimlik No",
  "qf.phone": "Cep telefonu",
  "qf.email": "E-posta (isteğe bağlı)",
  "qf.section.vehicle": "Araç bilgileri",
  "qf.plate": "Plaka (isteğe bağlı)",
  "qf.plateHint": "Örn. 34 ABC 123 — yoksa boş bırakın; girilirse geçerli olmalı.",
  "qf.plateInvalid": "Plaka formatı geçersiz (ör. 34 ABC 123).",
  "qf.make": "Marka (isteğe bağlı)",
  "qf.model": "Model (isteğe bağlı)",
  "qf.section.consent": "Onay (yasal kayıt)",
  "qf.noticeRef": "Aydınlatma metni müşteriye iletildi ve onayı alındı.",
  "qf.serviceAttest": "Aydınlatma metni okundu ve müşteri hizmet iletişimine onay verdi.",
  "qf.marketingAttest": "Müşteri pazarlama iletişimine de onay verdi (isteğe bağlı).",
  "qf.iysNote": "Pazarlama onayı kaydedilir ancak pilotta İYS mesajı gönderilmez.",
  "qf.continue": "Devam",
  "qf.step1Locked":
    "Bu adım kaydedildi (müşteri, hane ve talep oluşturuldu). Bilgilerde düzeltme gerekiyorsa müşteri kaydından yapın — buradaki değişiklikler kaydedilmez.",
  "qf.back": "Geri",
  "qf.saving": "Kaydediliyor…",
  "qf.captureError": "Kayıt oluşturulamadı. Lütfen tekrar deneyin.",
  "qf.dedup": "Bu telefon veya T.C. kimlik no ile kayıtlı bir müşteri zaten var.",
  "qf.dedupSearch": "Mevcut müşteriyi ara →",
  "qf.assetError":
    "Müşteri ve lead oluşturuldu, ancak araç kaydı yapılamadı — sonra tekrar deneyin.",
  "qf.offersTitle": "Teklifler (1–3)",
  "qf.doneBadge": "Oluşturuldu",
  "qf.summaryTitle": "Kayıt tamamlandı",
  "qf.summaryCustomer": "Müşteri",
  "qf.summaryOffers": "Oluşturulan teklifler",
  "qf.leadRef": "Lead referansı",
  "qf.goToRecommendation": "Öneriye git",
  // Product lines (product-first Step 1 — full pilot set, mirrors intake).
  "qf.line.dask": "DASK (Zorunlu Deprem)",
  "qf.line.seyahat": "Seyahat Sağlık",
  "qf.line.saglik": "Sağlık (TSS/ÖSS)",
  // "Nereden geldi?" extra channels (no dedicated interaction enum → mapped to en yakın değer).
  "qf.channel.INTERNET_AD": "İnternet reklamı",
  "qf.channel.INSTAGRAM": "Instagram",
  "qf.channel.OTHER": "Diğer",
  "qf.channelOther": "Kanal açıklaması (Diğer)",
  "qf.channelOtherPlaceholder": "Örn. tavsiye, fuar…",
  // Yeni üye / Kayıtlı üye entry toggle.
  "qf.modeLabel": "Müşteri türü",
  "qf.mode.new": "Yeni üye",
  "qf.mode.registered": "Kayıtlı üye",
  "qf.reg.title": "Kayıtlı üye ara",
  "qf.reg.searchLabel": "Ad veya telefon ile ara",
  "qf.reg.placeholder": "Ad soyad veya telefon…",
  "qf.reg.go": "Ara",
  "qf.reg.loading": "Aranıyor…",
  "qf.reg.none": "Eşleşen kayıt bulunamadı.",
  "qf.reg.select": "Seç",
  "qf.reg.noHousehold": "Hane bağlı değil",
  "qf.reg.change": "Değiştir",
  "qf.reg.attach": "Mevcut kayda bağlanacak",
  "qf.reg.note":
    "Seçilen üye için yeni bir teklif hazırlanır; kişi yeniden oluşturulmaz (mevcut party/hane kullanılır).",
  "qf.reg.masked": "—",
  "qf.reg.noPhone": "Telefon kayıtta dönmüyor",
  "qf.reg.tcknFlag": "T.C. kimlik no arama sonucunda maskeli/dönmüyor; teklif için gerekmez.",
  "qf.reg.emailFlag": "E-posta arama sonucunda dönmüyor.",
  "qf.dedupRegistered": "Kayıtlı üyeden devam et",
  "rec.heading": "Öneriler",
  "rec.create": "Yeni öneri",
  "rec.householdId": "Hane (household) kimliği",
  "rec.lineCode": "Branş",
  "rec.mustHaves": "Olmazsa olmazlar",
  "rec.priorities": "Öncelikler",
  "rec.budget": "Bütçe duruşu",
  "rec.start": "Öneriyi başlat",
  // Öneri (ihtiyaç değerlendirmesi) redesign — picker + çipler + segmented duruş.
  "rec.needs.subtitle": "İhtiyaç değerlendirmesi — öneriyi başlatın",
  "rec.needs.suggestTitle": "Bu adım yalnızca ihtiyacı toplar",
  "rec.needs.suggestBody":
    "Skor ve fiyat burada hesaplanmaz — sistem sunucu tarafında hesaplar ve önerir; kararı siz verirsiniz.",
  "rec.household.label": "Hane",
  "rec.household.hint": "Öneriyi bağlayacağınız haneyi seçin (yalnızca size atanmış müşteriler).",
  "rec.household.search": "Hane ara (ad veya telefon)",
  "rec.household.placeholder": "Ad veya telefon ile arayın…",
  "rec.household.go": "Ara",
  "rec.household.loading": "Aranıyor…",
  "rec.household.none": "Eşleşen hane bulunamadı.",
  "rec.household.select": "Seç",
  "rec.household.change": "Değiştir",
  "rec.household.noHousehold": "Hane yok",
  "rec.line.hint":
    "Branşlar katalogdan ve panel yetkisinden gelir; kapalı olanlar sebebiyle görünür.",
  "rec.asset.label": "Sigortalanacak varlık",
  "rec.asset.hint":
    "Poliçeleştirme için varlık zorunlu; hanenin bu branşa uygun varlıkları listelenir.",
  "rec.asset.loading": "Varlıklar yükleniyor…",
  "rec.asset.error": "Hanenin varlıkları okunamadı. Sayfayı yenileyip tekrar deneyin.",
  "rec.asset.none":
    "Bu hanede bu branşa uygun kayıtlı varlık yok. Öneriyi yine de oluşturabilirsiniz ama varlık olmadan POLİÇELEŞTİRİLEMEZ. Varlığı Teklif Formu'nda kaydedin.",
  "rec.asset.toQuoteForm": "Teklif Formu'na git",
  "rec.asset.required": "Devam etmek için bir varlık seçin.",
  "rec.line.trafik": "Trafik",
  "rec.line.kasko": "Kasko",
  "rec.line.dask": "DASK",
  "rec.line.konut": "Konut",
  "rec.line.tss": "TSS",
  "rec.line.oss": "ÖSS",
  "rec.line.seyahat": "Seyahat",
  "rec.line.closed": "Sonraki dilimde",
  "rec.line.closedWhy": "Pilotta yalnız panelin yetkili olduğu branşlar açık.",
  "rec.mustHaves.hint":
    "Kanonik teminat listesinden karşılanması zorunlu olanları seçin (hard-gate).",
  "rec.priorities.hint": "Önemli ama zorunlu olmayan teminatlar — sıralamayı yumuşak etkiler.",
  "rec.concepts.locked": "Teminat listesi için katalog okuma yetkisi gerekiyor.",
  "rec.concepts.loading": "Teminatlar yükleniyor…",
  "rec.concepts.none": "Bu branş için tanımlı teminat konsepti yok.",
  "rec.budget.hint": "Danışanın bütçe duruşu — sunucu fiyat-değer dengesini buna göre tartar.",
  "rec.budget.cheapest": "En uygun",
  "rec.budget.balanced": "Dengeli",
  "rec.budget.bestProtection": "En iyi koruma",
  "rec.loading": "Öneri yükleniyor…",
  "rec.error": "Öneri yüklenemedi.",
  "rec.comp.needsFit": "İhtiyaç Uyumu",
  "rec.comp.carrierQuality": "Sigortacı Kalitesi",
  "rec.comp.coverageQuality": "Teminat Kalitesi/İhtiyaç",
  "rec.comp.priceValue": "Fiyat Değeri",
  "rec.suitability": "Uygunluk",
  "rec.suggestion": "Önerilen",
  "rec.chosen": "Seçildi",
  "rec.premium": "Prim",
  "rec.citation": "Dayanak",
  "rec.qualitySnapshot": "kalite anlık görüntüsü",
  "rec.equivVersion": "denklik sürümü",
  "rec.hardGate": "Karşılanmayan olmazsa olmaz",
  "rec.offerEntry": "Teklif girişi",
  "rec.offerId": "Teklif (offer) kimliği",
  "rec.offerIdHint":
    "Teklif Formu / 3-Teklif akışında oluşan teklif kayıtlarının kimlikleri. Birden fazlaysa her satıra bir tane yazın. (Bu adımda teklif seçici yok — başvuru üstünde teklif listesi okuması bulunmuyor.)",
  "rec.addOffer": "Teklif ekle",
  "rec.score": "Puanla",
  "rec.choose": "Seç",
  "rec.confirmChoice": "Seçimi onayla",
  "rec.reasonCode": "Gerekçe kodu",
  "rec.rationale": "Daha-ucuz-değil gerekçesi",
  "rec.rationaleRequired": "En ucuz olmayan bir teklif için gerekçe zorunlu.",
  "rec.advisorNote": "Müşteriye not (opsiyonel)",
  "rec.advisorNoteHint": "Müşteriye gösterilir ve kayda geçer — özel/sağlık bilgisi yazmayın.",
  "rec.advisorNoteCounter": "Karakter sayısı",
  "rec.status": "Durum",
  "rec.pendingTier2": "İkinci onay bekleniyor (Tier-2)",
  "rec.tier2.requestApproval": "Onay talep et",
  "rec.tier2.awaiting": "Onay bekleniyor…",
  "rec.tier2.approved": "Onaylandı — Tier-2 incelemesini tamamla",
  "rec.tier2.complete": "Tier-2 incelemesini tamamla",
  "rec.tier2.grant": "Onayı ver",
  "rec.tier2.decline": "Reddet",
  "rec.tier2.declineReason": "Reddetme gerekçesi:",
  "rec.tier2.noApproval": "Bu öneri için bekleyen onay yok.",
  "rec.tier2.selfHint": "Kendi talebinizi onaylayamazsınız (ikinci kişi gerekir).",
  "rec.present": "Müşteriye sunuldu — kararı kaydet",
  "rec.decision": "Müşteri kararı",
  "rec.accepted": "Kabul",
  "rec.declined": "Ret",
  "rec.deferred": "Erteleme",
  "rec.declineReason": "Ret gerekçesi",
  "rec.decided": "Karar kaydedildi",
  "rec.issue": "Poliçeleştir",
  "rec.issueNoAsset":
    "Bu öneride sigortalı varlık tanımlı değil — poliçeleştirme için varlık gerekir.",
  "rec.delivery.title": "Teklifi ilet",
  "rec.delivery.pdf": "Teklif PDF indir",
  "rec.delivery.pdfLoading": "PDF hazırlanıyor…",
  "rec.delivery.pdfError": "PDF alınamadı — lütfen tekrar deneyin.",
  "rec.delivery.link": "WhatsApp linki oluştur → kopyala",
  "rec.delivery.linkLoading": "Link oluşturuluyor…",
  "rec.delivery.linkError": "Link oluşturulamadı — lütfen tekrar deneyin.",
  "rec.delivery.copied": "Link kopyalandı — WhatsApp'a yapıştırabilirsiniz.",
  "rec.delivery.copyManual": "Link hazır — aşağıdan kopyalayın (pano erişimi yok).",
  "rec.delivery.expiry": "Bu link 7 gün geçerlidir.",
  "rec.customerResponse.heading": "Müşteri yanıtı",
  "rec.customerResponse.said": "Müşteri",
  "rec.customerResponse.history": "Önceki yanıtlar",
  "rec.response.ACCEPTED": "kabul etti",
  "rec.response.DECLINED": "reddetti",
  "rec.response.DEFERRED": "erteledi",
  "rec.pending.heading": "Yanıt bekleyen öneriler",
  "rec.pending.empty": "Bekleyen müşteri yanıtı yok.",
  "hh.heading": "Müşteri 360",
  "hh.householdId": "Hane (household) kimliği",
  "hh.open": "Aç",
  "hh.search.label": "Telefon veya isimle ara",
  "hh.search.placeholder": "+9055… veya Ayşe",
  "hh.search.go": "Ara",
  "hh.search.byPhone": "Telefona göre arıyor",
  "hh.search.byName": "İsme göre arıyor",
  "hh.search.loading": "Aranıyor…",
  "hh.search.none": "Sonuç yok.",
  "hh.search.noHousehold": "hane bağlantısı bekleniyor",
  "hh.list.title": "Müşteriler",
  "hh.list.loading": "Müşteriler yükleniyor…",
  "hh.list.empty": "Henüz müşteri yok.",
  "hh.list.error": "Müşteri listesi yüklenemedi.",
  "hh.list.more": "Daha fazla",
  "hh.advanced": "Gelişmiş — kimlikle aç",
  // Müşterilerim — the advisor's own book (default view + server-side filter tabs).
  "hh.book.tabsLabel": "Hane filtreleri",
  "hh.book.tab.mine": "Benim hanelerim",
  "hh.book.tab.actionPending": "Aksiyon bekleyen",
  "hh.book.tab.careHold": "Care-hold",
  "hh.book.count": "hane",
  "hh.book.loading": "Hane defteri yükleniyor…",
  "hh.book.error": "Hane defteri yüklenemedi.",
  "hh.book.empty": "Bu filtrede hane yok.",
  "hh.book.members": "üye",
  "hh.book.policies": "poliçe",
  "hh.book.renewalDue": "⟳ Yenileme yaklaşıyor",
  "hh.book.careHold": "⚑ satış susturuldu",
  "hh.book.nextAction": "Sıradaki adım",
  "hh.book.na.renewal": "Yenileme yaklaşıyor",
  "hh.book.na.quote": "Teklif bekliyor",
  "hh.book.na.lead": "Yeni müşteri adayı",
  "hh.book.na.claim": "Hasar takibi",
  "hh.book.na.alert": "İncelenecek uyarı",
  "hh.book.na.service": "Servis takibi",
  "hh.polStatus.ACTIVE": "Aktif",
  "hh.polStatus.CANCELLATION_REQUESTED": "İptal talep edildi",
  "hh.polStatus.CANCELLED": "İptal edildi",
  "hh.polStatus.RENEWED": "Yenilendi",
  "hh.polStatus.EXPIRED": "Süresi doldu",
  "hh.loading": "Hane yükleniyor…",
  "hh.error": "Hane yüklenemedi.",
  "hh.owner": "İlişki sahibi danışman",
  "hh.since": "sahiplik",
  "hh.members": "Üyeler",
  "hh.policies": "Yürürlükteki poliçeler",
  "hh.engagement": "Etkileşim kaydı",
  "hh.lifeEvents": "Yaşam olayları",
  "hh.tl.title": "Zaman çizelgesi",
  "hh.tl.interaction": "Görüşme",
  "hh.tl.lifeEvent": "Yaşam olayı",
  "hh.tl.recommendation": "Öneri",
  "hh.tl.claim": "Hasar",
  "hh.tl.policy": "Poliçe",
  "hh.tl.care": "Care — satış yok",
  "hh.consent": "Onay durumu",
  "hh.crossLinks": "Bağlantılar",
  "hh.none": "Kayıt yok.",
  "hh.careHold": "BAKIM (CARE) — satış askıda",
  "hh.term": "Dönem",
  "hh.marketingOk": "Pazarlama onayı var",
  "hh.consentWithdraw": "Onayı geri çek",
  "hh.consentWithdrawYes": "Evet, geri çek",
  "hh.consentWithdrawNo": "Vazgeç",
  "hh.consentWithdrawConfirm":
    "Bu kişinin pazarlama onayı geri çekilecek ve bundan sonra pazarlama iletişimine dâhil edilmeyecek. Onayı yalnızca müşteri kendisi yeniden verebilir. Devam edilsin mi?",
  "hh.marketingNo": "Pazarlama onayı yok",
  "hh.tckn.show": "TCKN göster",
  "hh.tckn.hide": "Gizle",
  "hh.tckn.loading": "Getiriliyor…",
  "hh.tckn.error": "TCKN alınamadı — lütfen tekrar deneyin.",
  "pol.loading": "Poliçe yükleniyor…",
  "pol.error": "Poliçe yüklenemedi.",
  "pol.heading": "Poliçe",
  "pol.status": "Durum",
  "pol.term": "Vade",
  "pol.endorse.title": "Zeyilname",
  "pol.endorse.note": "Değişiklik notu",
  "pol.endorse.add": "Zeyil ekle",
  "pol.endorse.created": "Zeyil oluşturuldu",
  "pol.endorse.effect": "Etkinleştir",
  "pol.endorse.effected": "Etkinleştirildi",
  "pol.endorse.noEffect": "Etkinleştirme yetkisi gerekiyor (application:issue).",
  "pol.endorse.inactive": "Zeyil yalnızca aktif poliçede eklenebilir.",
  "pol.cancel.title": "İptal",
  "pol.cancel.subtype": "İptal türü",
  "pol.cancel.subtype.CUSTOMER": "Müşteri talebi",
  "pol.cancel.subtype.CARRIER_NONPAYMENT": "Ödememe (şirket)",
  "pol.cancel.subtype.CSA": "CSA (dört-göz)",
  "pol.cancel.reason": "Gerekçe",
  "pol.cancel.request": "Poliçe iptal",
  "pol.cancel.requested": "İptal talep edildi",
  "pol.cancel.returnPremium": "İade prim (varsa)",
  "pol.cancel.confirm": "İptali onayla",
  "pol.cancel.done": "Poliçe iptal edildi",
  "pol.cancel.notApplicable": "Bu poliçe durumunda iptal işlemi yapılamaz.",
  "pol.cancel.returned": "İade prim:",
  "hh.links.recommendations": "Öneriler",
  "hh.rec.item": "Öneri",
  "hh.opportunities": "Fırsatlar",
  "hh.renewal": "Yenileme",
  "hh.commission": "Komisyon",
  "hh.gap": "Fark",
  "hh.panelError": "Yüklenemedi.",
  "hh.oppType.UNINSURED_VEHICLE": "Sigortasız araç",
  "hh.oppType.KASKO_GAP": "Kasko açığı",
  "hh.oppType.LAPSED_NOT_RENEWED": "Yenilenmemiş poliçe",
  "hh.eventType.NEW_VEHICLE": "Yeni araç",
  "hh.eventType.CHILD_BIRTH": "Çocuk doğumu",
  "hh.eventType.NEW_DEPENDENT": "Yeni bakmakla yükümlü",
  "hh.eventType.HOME_PURCHASE": "Ev alımı",
  "hh.eventType.MARRIAGE": "Evlilik",
  "hh.eventType.BEREAVEMENT": "Vefat",
  "hh.eventType.ILLNESS": "Hastalık",
  "hh.eventType.INJURY": "Yaralanma",
  "hh.eventType": "Olay türü",
  "hh.engage.touches": "Son 30 gün çapraz-satış teması",
  "hh.engage.lastContact": "Son temas",
  "hh.markActioned": "İşleme alındı",
  "hh.addLifeEvent": "Ekle",
  "hh.ownershipActions": "Sahiplik işlemleri",
  "hh.reassign.title": "Sahip değiştir",
  "hh.reassign.toAdvisor": "Yeni danışman kimliği",
  "hh.reassign.reason": "Gerekçe",
  "hh.reassign.submit": "Sahibi değiştir",
  "hh.participation.title": "Katılımcı ekle",
  "hh.participation.function": "İşlev",
  "hh.participation.context": "Görev bağlamı",
  "hh.participation.submit": "Katılımı kaydet",
  "hh.participation.ok": "Katılım kaydedildi.",
  "book.title": "Hane Defterim",
  "book.loading": "Yükleniyor…",
  "book.error": "Defter yüklenemedi.",
  "book.empty": "Henüz size atanmış hane yok.",
  "book.since": "sahiplik",
  "hh.links.claims": "Hasarlar",
  "hh.links.queue": "Kuyruk",
  "hh.log.heading": "Etkileşim kaydet",
  "hh.log.channel": "Kanal",
  "hh.log.direction": "Yön",
  "hh.log.intent": "Amaç",
  "hh.log.consent": "Onay durumu",
  "hh.log.submit": "Kaydet",
  "hh.log.marketingHint": "Pazarlama amacı: onay yoksa fırsat olarak kaydedilir (temas yok).",
  "hh.log.logged": "Etkileşim kaydedildi.",
  "claims.heading": "Hasar Masası",
  "claims.loading": "Hasarlar yükleniyor…",
  "claims.error": "Hasar yüklenemedi.",
  "claims.none": "Açık hasar yok.",
  "claims.careMode":
    "Bakım modu: açık hasarı olan haneler için satış sinyalleri bastırılır. Bu ekranda öneri aksiyonu yoktur — yalnızca takip ve bilgilendirme.",
  "claims.status": "Durum",
  "claims.line": "Branş",
  "claims.carrier": "Sigortacı",
  "claims.loss": "Hasar tarihi",
  "claims.versionAtLoss": "Hasar anı poliçe sürümü",
  "claims.outcome": "Sonuç",
  "claims.injury": "Bedeni zarar",
  "claims.thirdParty": "Üçüncü taraf",
  "claims.timeline": "Savunuculuk zaman çizelgesi",
  "claims.advance": "İlerlet",
  "claims.carrierRefPrompt": "Sigortacı hasar referansı:",
  "claims.fnol.heading": "Yeni hasar bildirimi (FNOL)",
  "claims.fnol.policyId": "Poliçe kimliği",
  "claims.fnol.lossAt": "Hasar tarihi/saati",
  "claims.fnol.bodilyInjury": "Bedeni zarar içeriyor",
  "claims.fnol.thirdParty": "Üçüncü taraf var",
  "claims.fnol.careWarning":
    "Bedeni zarar bir BAKIM (CARE) askısı tetikler — bu hane için satış askıya alınır.",
  "claims.fnol.file": "Hasarı aç",
  "claims.event.heading": "Kayıt ekle",
  "claims.event.type": "Tür",
  "claims.event.note": "Not (hassas olmayan)",
  "claims.event.add": "Ekle",
  "claims.resolve.heading": "Sonuçlandır",
  "claims.resolve.outcome": "Sonuç",
  "claims.resolve.amount": "Tutar (sigortacı bildirimi)",
  "claims.resolve.satisfaction": "Memnuniyet (1–5)",
  "claims.resolve.resolve": "Sonuçlandır",
  "claims.resolve.withdraw": "Geri çek",
  "claims.resolve.amountRequired":
    "Ödendi / kısmen ödendi için kurum tutarı (0'dan büyük) gerekir.",
  "claims.resolve.rejectedNoAmount": "Reddedilen hasarda ödeme tutarı olmaz — tutarı boş bırakın.",
  "claims.resolve.needsInProgress":
    "Sonuç kaydı için hasarın “İşlemde” olması gerekir (kurum henüz yanıt vermedi). Yanlış açılmış bir hasarı aşağıdan geri çekebilirsiniz.",
  "claims.resolve.reason": "Geri çekme gerekçesi",
  "recon.heading": "Mutabakat",
  "recon.loading": "Yükleniyor…",
  "recon.error": "Mutabakat yüklenemedi.",
  "recon.totals": "Toplamlar",
  "recon.expected": "Beklenen",
  "recon.received": "Alınan",
  "recon.gap": "Fark",
  "recon.byCarrier": "Sigortacı bazında",
  "recon.entries": "kayıt",
  "recon.exceptions": "İstisnalar",
  "recon.variances": "Sapmalar",
  "recon.disputed": "İhtilaflı",
  "recon.clawedBack": "Geri alınan",
  "recon.unmatched": "Eşleşmeyen satırlar",
  "recon.missingRate": "Eksik oran (backlog)",
  // İstisna sınıfı etiketleri (API enum DEĞERLERİ değişmez — yalnızca gösterim + ipucu).
  "recon.status.EXPECTED": "Beklenen",
  "recon.status.RECONCILED": "Mutabık",
  "recon.status.VARIANCE": "Fark",
  "recon.status.DISPUTED": "İtirazlı",
  "recon.status.CLAWED_BACK": "Geri alındı",
  "recon.status.UNMATCHED": "Eşleşmemiş",
  "recon.status.MISSING_RATE": "Oran tanımsız",
  "recon.statusHelp.EXPECTED": "Bize düşmesi beklenen ama henüz ödenmemiş komisyon.",
  "recon.statusHelp.RECONCILED": "Beklenen ile ödenen eşleşti.",
  "recon.statusHelp.VARIANCE": "Ödenen tutar beklenenden farklı — tolerans dışı.",
  "recon.statusHelp.DISPUTED": "Fark için sigortacıya itiraz açıldı.",
  "recon.statusHelp.CLAWED_BACK": "Sigortacının geri çektiği komisyon.",
  "recon.statusHelp.UNMATCHED": "Ekstredeki bu satır hiçbir beklenen kayıtla eşleşmedi.",
  "recon.statusHelp.MISSING_RATE": "Komisyon oranı tanımlı değil — beklenen tutar hesaplanamadı.",
  "recon.none": "Kayıt yok.",
  "recon.dispute.open": "İhtilaf aç",
  "recon.dispute.resolve": "Çöz",
  "recon.dispute.reasonPrompt": "İhtilaf gerekçesi:",
  "recon.actionFailed": "İşlem kaydedilemedi. Kalem durumu değişmedi.",
  "recon.dispute.resolvedReconciled": "Çöz → Mutabık",
  "recon.dispute.resolvedVariance": "Çöz → Sapma",
  "recon.stmt.heading": "Ekstre girişi",
  "recon.stmt.carrierId": "Sigortacı kimliği",
  "recon.stmt.periodStart": "Dönem başı",
  "recon.stmt.periodEnd": "Dönem sonu",
  "recon.stmt.total": "Ekstre toplamı",
  "recon.stmt.ref": "Poliçe referansı",
  "recon.stmt.lineType": "Tür",
  "recon.stmt.amount": "Tutar",
  "recon.stmt.addLine": "Satır ekle",
  "recon.stmt.submit": "Ekstreyi gönder",
  "recon.stmt.incomplete": "Kurum, dönem başlangıcı/bitişi ve toplam tutar zorunludur.",
  "recon.bulk.heading": "Toplu ekstre girişi",
  "recon.bulk.coveredRefs": "Kapsanan poliçe referansları (virgül/satır)",
  "recon.bulk.submit": "Toplu ekstreyi gönder",
  "recon.bulk.incomplete": "Kurum, dönem, toplam tutar ve en az bir kurum referansı zorunludur.",
  "recon.bulk.result": "Dağıtım sonucu (tahmini paylaştırma)",
  "recon.bulk.estimatedNote": "Tutarlar Beklenen'e orantılı paylaştırıldı (is_estimated).",
  "inbox.heading": "Onay Kutusu",
  "inbox.loading": "Yükleniyor…",
  "inbox.none": "Bekleyen onay yok.",
  "inbox.action": "İşlem",
  "inbox.resource": "Kaynak",
  "inbox.requester": "Talep eden",
  "inbox.approve": "Onayla",
  "inbox.reject": "Reddet",
  "inbox.rejectReason": "Reddetme gerekçesi (zorunlu):",
  "inbox.rejectConfirm": "Reddi onayla",
  "inbox.actionFailed": "Onay işlemi kaydedilemedi. Karar alınmadı.",
  // Shared offline copy for MutationError. status 0 means fetch itself rejected —
  // the server said nothing, so the UI must not report a server verdict.
  "common.offline": "Bağlantı kurulamadı. İşlem sunucuya ulaşmadı.",
  "iss.actionFailed": "İşlem kaydedilmedi. Poliçe durumu değişmedi.",
  "hh.actionFailed": "Kayıt yapılamadı. Değişiklik uygulanmadı.",
  "q.actionFailed": "İşlem kaydedilemedi. Kuyruk kaydı değişmedi.",
  "queue.promptUnavailable":
    "Bu tarayıcıda gerekli açıklama sorulamıyor, bu yüzden işlem başlatılmadı.",
  "cl.actionFailed": "İşlem kaydedilemedi. Hasar durumu değişmedi.",
  "rec.actionFailed": "İşlem kaydedilemedi. Öneri değişmedi.",
  "crm.actionFailed": "İşlem kaydedilemedi.",
  "crm.loadFailed": "Liste okunamadı. Kayıt OLMADIĞI anlamına gelmez.",
  "inbox.review": "İncele",
  "inbox.noReview": "Bu işlem için inceleme ekranı yok",
  "inbox.tabs.label": "Onay listeleri",
  "inbox.tab.awaiting": "Bana onay bekleyenler",
  "inbox.tab.sent": "Gönderdiklerim",
  "inbox.sent.none": "Henüz onay talebi göndermediniz.",
  "inbox.status.PENDING": "Beklemede",
  "inbox.status.APPROVED": "Onaylandı",
  "inbox.status.REJECTED": "Reddedildi",
  "inbox.status.CONSUMED": "Kullanıldı",

  // B5 — issuance desk
  "iss.heading": "Poliçeleştirme Masası",
  "iss.restricted": "Bu masayı görüntülemek için yetkiniz yok.",
  "iss.exceptionsWaiting": "Bekleyen istisna",
  // Shared DateTimeField affordances (web-foundation). The console had no df.* keys
  // until D16 brought the re-quote panel — the component was admin-only before that.
  "df.today": "Bugün",
  "df.now": "Şimdi",
  "iss.loading": "Yükleniyor…",
  "iss.error": "Başvurular yüklenemedi.",
  "iss.empty": "Açık başvuru yok.",
  "iss.detailHeading": "Poliçe başvurusu",
  "iss.acceptedPrice": "Kabul edilen prim",
  "iss.issuedPrice": "Düzenlenen prim",
  "iss.issuedPremium": "Düzenlenen prim",
  "iss.line": "Ürün",
  "iss.carrier": "Sigorta şirketi",
  "iss.line.trafik": "Zorunlu Trafik",
  "iss.line.kasko": "Kasko",
  "iss.status.DRAFT": "Taslak",
  "iss.status.SUBMITTED_TO_CARRIER": "Sigortacıya iletildi",
  "iss.status.ISSUANCE_PENDING": "Poliçeleştirme bekliyor",
  "iss.status.ISSUED": "Düzenlendi",
  "iss.status.ISSUANCE_EXCEPTION": "İstisna",
  "iss.status.QUOTE_REVALIDATION": "Teklif yenileme",
  "iss.status.WITHDRAWN": "Geri çekildi",
  "iss.status.DECLINED": "Reddedildi",
  "iss.status.FAILED": "Başarısız",
  "iss.exception.PRICE_INTEGRITY_FAIL": "Fiyat bütünlüğü uyuşmazlığı",
  "iss.exception.ISSUED_UNCONFIRMED": "Düzenlendi, doğrulanmadı",
  "iss.exception.PAID_NOT_ISSUED": "Ödendi, düzenlenmedi",
  "iss.stage.submit": "Sigortacıya ilet",
  "iss.stage.submitHint": "Başvuruyu sigorta şirketine iletin (teklif geçerliliği kontrol edilir).",
  "iss.action.submit": "İlet",
  "iss.stage.revalidate": "Teklifi yenile",
  "iss.stage.revalidateHint":
    "Teklif geçerliliği doldu. Devam etmek için kurumdan alınan YENİ teklifi girin — fiyat bütünlüğü bu yeni tekliften kontrol edilir.",
  "iss.revalidate.offerId": "Yeni teklif referansı",
  "iss.revalidate.offerIdHint":
    "Kurumun yeniden fiyatlamasıyla oluşan teklif kaydının kimliği. (Başvuru üstünde teklif listesi okuması yok — seçici backlog'ta.)",
  "iss.revalidate.acceptedAt": "Kabul tarihi",
  "iss.revalidate.validUntil": "Geçerlilik bitişi",
  "iss.action.revalidate": "Yeni teklifi bağla",
  "iss.stage.terminate": "Başvuruyu kapat",
  "iss.stage.terminateHint":
    "Bu başvuru poliçeleşmeyecekse kapatın. “Vazgeçildi” = biz durdurduk; “Kurum reddetti” = kurum kabul etmedi. İkisi ayrı kaydedilir; kurum kalite ölçümü bu farkı okur.",
  "iss.terminate.reason": "Gerekçe",
  "iss.action.withdraw": "Vazgeçildi",
  "iss.action.recordDeclined": "Kurum reddetti",
  "iss.stage.observe": "Ödeme gözlemi",
  "iss.stage.observeHint":
    "Müşterinin sigorta şirketine ödediğini gözlemleyip kaydedin. CSA para tutmaz; ödeme doğrudan sigorta şirketine yapılır.",
  "iss.paymentReference": "Ödeme referansı (sigorta şirketi tarafı)",
  "iss.action.observe": "Gözlemi kaydet",
  "iss.stage.confirm": "Poliçeleştirmeyi doğrula",
  "iss.gate.rule":
    "Düzenlenen prim, kabul edilen prime eşit olmalı ve kanıt referansı gerekli; aksi halde istisna oluşur",
  "iss.carrierPolicyNumber": "Sigortacı poliçe numarası",
  "iss.proofRef": "Kanıt referansı",
  "iss.proofN6Flag":
    "Belge yükleme N6 (Belgeler) ile gelecek — şimdilik kanıt bir referans/kimlik olarak girilir.",
  "iss.action.confirm": "Poliçeleştirmeyi doğrula",
  "iss.issuedBadge": "Aktif poliçe",
  "iss.issuedBody": "Poliçe düzenlendi — aktif poliçe oluşturuldu.",
  "iss.policyRef": "Poliçe referansı",
  "iss.exceptionHeading": "İstisna",
  "iss.statusField": "Durum",
  "iss.exceptionTypeField": "İstisna türü",
  "iss.exceptionExplain.PRICE_INTEGRITY_FAIL":
    "Düzenlenen prim, kabul edilen primle eşleşmedi. Poliçe otomatik olarak aktifleştirilmedi.",
  "iss.exceptionExplain.ISSUED_UNCONFIRMED":
    "Poliçe düzenlendi ancak kanıt referansı olmadan doğrulanamadı.",
  "iss.exceptionExplain.PAID_NOT_ISSUED":
    "Müşteri sigorta şirketine ödeme yaptı ancak poliçe henüz düzenlenmedi. En yüksek öncelikli durum — hemen ele alın.",
  "iss.offPriceFourEyes":
    "Fiyat farkıyla devam etmek çift-onay (four-eyes) gerektirir — tek kişi geçemez.",
  "iss.resolveReason": "Gerekçe",
  "iss.action.retry": "Yeniden dene",
  "iss.action.fail": "Başarısız işaretle",
  "iss.needWrite": "Bu işlem için application:write yetkisi gerekir.",
  "iss.needIssue": "Poliçeleştirme için application:issue yetkisi gerekir.",

  // B0 — phone lead-intake
  "intake.heading": "Telefonla Lead Kaydı",
  "intake.subheading": "Çağrıdaki arayanı kaydedin ve sözlü onayını alın. Fiyat/teklif verilmez.",
  "intake.restricted": "Bu işlem için lead:write, party:write ve capture:write yetkileri gerekir.",
  "intake.callerSection": "Arayan bilgileri",
  "intake.firstName": "Ad",
  "intake.lastName": "Soyad",
  "intake.phone": "Telefon",
  "intake.email": "E-posta (isteğe bağlı)",
  "intake.tckn": "T.C. Kimlik No",
  "intake.birthDate": "Doğum tarihi (isteğe bağlı)",
  "intake.il": "İl (isteğe bağlı)",
  "intake.ilce": "İlçe (isteğe bağlı)",
  "intake.meslek": "Meslek (isteğe bağlı)",
  "intake.commonCaptureNote":
    "Doğum tarihi ve il/ilçe şimdilik kayda alınır; ilgili alanlar backend sözleşmesi geldiğinde kalıcılaşır (backend-first).",
  "intake.productSection": "Ürün ilgisi",
  "intake.line": "Ürün",
  "intake.line.trafik": "Zorunlu Trafik",
  "intake.line.kasko": "Kasko",
  "intake.line.dask": "DASK (Zorunlu Deprem)",
  "intake.line.seyahat": "Seyahat Sağlık",
  "intake.line.saglik": "Sağlık (TSS/ÖSS)",
  "intake.selectPlaceholder": "Seçiniz…",
  "intake.notes": "Not (isteğe bağlı)",
  "intake.noPriceNote": "Bu adımda fiyat veya teklif verilmez — teklif sonradan hazırlanır.",
  "intake.vehicleSection": "Araç bilgileri",
  "intake.plate": "Plaka (isteğe bağlı)",
  "intake.plateHint": "Örn. 34 ABC 123 — çağrıda yoksa boş bırakın; girilirse geçerli olmalı.",
  "intake.plateInvalid": "Plaka formatı geçersiz (ör. 34 ABC 123).",
  "intake.make": "Marka (isteğe bağlı)",
  "intake.model": "Model (isteğe bağlı)",
  "intake.vin": "Şasi / VIN (isteğe bağlı)",
  "intake.vinHint": "17 haneli şasi numarası; isteğe bağlı.",
  "intake.vinInvalid": "Şasi (VIN) 17 haneli olmalı.",
  "intake.ruhsat": "Tescil (ruhsat) seri no (isteğe bağlı)",
  "intake.ehliyetDate": "Ehliyet alış tarihi (isteğe bağlı)",
  // A3 — `intake.assetError` was REMOVED with the six-POST chain: the state it
  // described (lead saved, asset not) cannot occur inside one transaction.
  // DASK — konut/bina (canonical §3)
  "intake.dwellingSection": "Konut bilgileri (DASK)",
  "intake.address": "Tam açık adres (isteğe bağlı)",
  "intake.uavt": "UAVT adres kodu (isteğe bağlı)",
  "intake.uavtHint":
    "10 haneli UAVT adres kodu — e-Devlet'ten alınır; girilirse DASK varlığına yazılır.",
  "intake.uavtInvalid": "UAVT adres kodu 10 haneli olmalı.",
  "intake.brutM2": "Brüt m² (isteğe bağlı)",
  "intake.yapiTarzi": "Yapı tarzı (isteğe bağlı)",
  "intake.yapiTarzi.betonarme": "Betonarme",
  "intake.yapiTarzi.celik": "Çelik",
  "intake.yapiTarzi.yigma": "Yığma",
  "intake.yapiTarzi.diger": "Diğer",
  "intake.insaYili": "İnşa (yapım) yılı (isteğe bağlı)",
  "intake.kat": "Bulunduğu kat (isteğe bağlı)",
  "intake.dwellingCaptureNote":
    "m² / yapı tarzı / inşa yılı / kat şimdilik kayda alınır; ilgili sözleşme geldiğinde kalıcılaşır (backend-first).",
  // Seyahat (canonical §4)
  "intake.travelSection": "Seyahat bilgileri",
  "intake.travelDestination": "Gidilecek ülke / bölge (isteğe bağlı)",
  "intake.travelStart": "Başlangıç tarihi (isteğe bağlı)",
  "intake.travelEnd": "Bitiş tarihi (isteğe bağlı)",
  "intake.travelers": "Kişi sayısı (isteğe bağlı)",
  "intake.travelCaptureNote":
    "Seyahat alanları şimdilik kayda alınır; ilgili sözleşme geldiğinde kalıcılaşır (backend-first).",
  // Sağlık (canonical §5) — SGK + hastane; sağlık beyanı YOK (özel nitelikli, çevrimdışı)
  "intake.healthSection": "Sağlık bilgileri",
  "intake.sgkStatus": "SGK durumu (isteğe bağlı)",
  "intake.sgk.sgkli": "SGK'lı",
  "intake.sgk.sgksiz": "SGK'sız",
  "intake.sgk.bilinmiyor": "Bilinmiyor",
  "intake.hospitalPref": "Kapsam / anlaşmalı hastane tercihi (isteğe bağlı)",
  "intake.healthOfflineNote":
    "Sağlık beyanı burada alınmaz — özel nitelikli veri, go-live öncesi çevrimdışı tutulur. SGK/hastane alanları şimdilik kayda alınır (backend-first).",
  "intake.consentSection": "Sözlü onay (yasal kayıt)",
  "intake.noticeRef": "Aydınlatma metni çağrıda okundu",
  "intake.noticeVersionLabel": "Sürüm",
  "intake.serviceAttest": "Aydınlatma metni okundu ve arayan hizmet iletişimine sözlü onay verdi.",
  "intake.marketingAttest": "Arayan pazarlama iletişimine de sözlü onay verdi (isteğe bağlı).",
  "intake.healthAttest":
    "Arayan sağlık verisinin işlenmesine AYRI açık rıza verdi (özel nitelikli).",
  "intake.healthConsentNote":
    "Sağlık açık rızası ayrı bir izindir; şimdilik kayda alınır ancak özel nitelikli izin sözleşmesi geldiğinde kalıcılaşır (backend-first).",
  "intake.iysNote": "Pazarlama onayı kaydedilir ancak pilotta İYS mesajı gönderilmez.",
  "intake.error": "Kayıt oluşturulamadı. Lütfen tekrar deneyin.",
  "intake.dedup": "Bu telefon veya T.C. kimlik no ile kayıtlı bir müşteri zaten var.",
  "intake.dedupSearch": "Mevcut müşteriyi ara →",
  "intake.submit": "Lead oluştur",
  "intake.doneBadge": "Oluşturuldu",
  "intake.doneTitle": "Lead oluşturuldu",
  "intake.doneBody": "Arayan huniye girdi; öneri akışından devam edilebilir.",
  "intake.leadRef": "Lead referansı",
  "intake.another": "Yeni kayıt",

  // BUGÜN — Günüm ("My Day") dashboard. Calm, komisyonsuz, tahminsiz; her sıfır
  // dürüst-boş bir hâl olarak gösterilir (uydurma sayı yok).
  "gunum.heading": "Günüm",
  "gunum.subtitle": "Bugünkü işleriniz, tek bakışta.",
  "gunum.loading": "Günümüz hazırlanıyor…",
  "gunum.error.title": "Pano şu an yüklenemedi",
  "gunum.error.detail": "Günüm panosu yüklenemedi.",
  "gunum.error.reassure": "Kuyruğunuz bundan etkilenmez — işleriniz yerinde.",
  "gunum.retry": "Yeniden dene",
  "gunum.empty.title": "Veriler birikiyor",
  "gunum.empty.desc": "İlk müşterilerinizle burası dolacak.",
  "gunum.scopeHint": "Kendim ↔ Ekibim",
  "gunum.scope.group": "Kapsam seçimi",
  "gunum.scope.own": "Kendim",
  "gunum.scope.team": "Kapsam: Ekibim",
  "gunum.scope.all": "Kapsam: Tüm defter",
  // (1) Kapasite & kuyruk
  "gunum.cap.title": "Kapasite & kuyruk",
  "gunum.cap.totalLabel": "bugünkü iş",
  "gunum.cap.utilization": "kapasite kullanımı",
  "gunum.cap.healthy": "Kapasite sağlıklı",
  "gunum.cap.tight": "Kapasite dolmak üzere",
  "gunum.cap.empty": "Bugün açık iş yok — kuyruk temiz.",
  "gunum.cap.link": "Kuyruğa git",
  // (2) SLA sağlığı
  "gunum.sla.title": "SLA sağlığı",
  "gunum.sla.onTime": "Zamanında",
  "gunum.sla.atRisk": "Risk altında",
  "gunum.sla.breached": "Aşıldı",
  "gunum.sla.trend": "Son 7 gün",
  "gunum.sla.trendAria": "Son 7 günde SLA taşıyan açık iş eğilimi:",
  "gunum.sla.trendUp": "yükseliyor",
  "gunum.sla.trendDown": "azalıyor",
  "gunum.sla.trendFlat": "yatay",
  "gunum.sla.empty": "SLA taşıyan açık iş yok.",
  "gunum.sla.link": "Kuyruğa git",
  // (3) Portföy derinliği
  "gunum.depth.title": "Portföy derinliği",
  "gunum.depth.households": "hane",
  "gunum.depth.activePolicies": "yürürlükteki poliçe",
  "gunum.depth.perHousehold": "hane başına poliçe",
  "gunum.depth.median": "ortanca",
  "gunum.depth.range": "poliçe aralığı",
  "gunum.depth.service":
    "Derinlik bir hizmet göstergesi — sığ haneler ilgilenilecek hanelerdir, satış hedefi değil.",
  "gunum.depth.empty": "Henüz hane yok.",
  "gunum.depth.link": "Müşterilere git",
  // (4) Yenileme hattı
  "gunum.renew.title": "Yenileme hattı",
  "gunum.renew.t45": "T-45",
  "gunum.renew.t7": "T-7",
  "gunum.renew.expiry": "Süresi geçti",
  "gunum.renew.empty": "Aktif yenileme yok.",
  "gunum.renew.note":
    "Hiçbiri sessizce düşmez — her biri kuyruğunuzda Kritik olarak açık; bastırılamaz.",
  "gunum.renew.link": "Yenilemelere git",
  // (5) Dönüşüm
  "gunum.conv.title": "Dönüşüm",
  "gunum.conv.acceptRate": "kabul oranı",
  "gunum.conv.realized": "gerçekleşen (kabul/sunulan)",
  "gunum.conv.mix": "Teklif dağılımı",
  "gunum.conv.motor": "Motor",
  "gunum.conv.health": "Sağlık / TSS",
  "gunum.conv.other": "Diğer",
  "gunum.conv.stageB": "Stage B — tahmin bilerek yok; yalnızca gerçekleşen gösterilir.",
  "gunum.conv.empty": "Bu dönem sunulan teklif yok.",
  "gunum.conv.link": "Önerilere git",
  // (6) Güven & uyum şeridi
  "gunum.trust.title": "Güven & uyum",
  "gunum.trust.suppressedLabel": "iş bu dönem bastırıldı",
  "gunum.trust.suppressedNote": "no-spam kanıtı — göndermediklerimiz de kayıtlı.",
  "gunum.trust.careHoldLabel": "hane care-hold'da",
  "gunum.trust.careHoldNote": "BAKIM (CARE) askısı — bu hanelerde satış susar.",
  "gunum.trust.framing": "Aramadıklarımız da işimizin bir parçası.",
  "gunum.trust.empty": "Bu dönem bastırılan iş yok; hiçbir hane care-hold'da değil.",
  "gunum.trust.link": "Kuyruğa git",
  // Yenilemeler yüzeyi — yenileme kadans hattı (T-45 → Süresi geçti)
  "renewals.heading": "Yenilemeler",
  "renewals.subtitle":
    "Kitabınızdaki aktif yenileme hattı — kadans aşamasına göre. Yalnızca mevcut durum; tahmin yok.",
  "renewals.loading": "Yenileme hattı yükleniyor…",
  "renewals.error.title": "Yenilemeler açılamadı",
  "renewals.error.detail": "Yenileme hattı şu an okunamadı.",
  "renewals.error.reassure": "Hiçbir yenileme kaybolmadı — tekrar deneyebilirsiniz.",
  "renewals.retry": "Tekrar dene",
  "renewals.cadence.title": "Yenileme kadans hattı",
  "renewals.stage.t45": "T-45",
  "renewals.stage.t30": "T-30",
  "renewals.stage.t15": "T-15",
  "renewals.stage.t7": "T-7",
  "renewals.stage.expired": "Süresi geçti",
  "renewals.total": "aktif yenileme",
  "renewals.note":
    "Hiçbiri sessizce düşmez — her biri kuyruğunuzda Kritik olarak açık; bastırılamaz.",
  "renewals.duty.title": "Sigortasız kalan yenileme — 24 saatlik bakım yükümlülüğü",
  "renewals.duty.desc":
    "Bir yenileme son 24 saat içinde süresini doldurdu ve varlık için başka aktif poliçe yok — sigortasız. 24 saatlik bakım yükümlülüğü kapsamında; kuyruğunuzda Kritik olarak açık.",
  "renewals.list.title": "Yaklaşan yenilemeler",
  "renewals.list.loading": "Yenilemeler yükleniyor…",
  "renewals.list.error": "Yenileme listesi şu an okunamadı.",
  "renewals.list.empty": "Yaklaşan yenileme yok",
  "renewals.list.more": "Daha fazla",
  "renewals.empty.title": "Yaklaşan yenileme yok",
  "renewals.empty.desc":
    "Kitabınızda aktif yenileme kadansı yok. Yeni yenileme açıldığında burada görünür.",
  // BİLDİRİMLER — the staff notification feed (secondary-surfaces §2). Operational
  // signals only; NO marketing. Critical = the genuine-alarm (red) tone.
  "notifications.heading": "Bildirimler",
  "notifications.subtitle":
    "Sizi bekleyen operasyonel sinyaller — kritik olanlar üstte. Pazarlama yok.",
  "notifications.loading": "Bildirimler yükleniyor…",
  "notifications.error.title": "Bildirimler açılamadı",
  "notifications.error.detail": "Bildirim akışı şu an okunamadı.",
  "notifications.error.reassure": "Hiçbir sinyal kaybolmadı — tekrar deneyebilirsiniz.",
  "notifications.retry": "Tekrar dene",
  "notifications.empty.title": "Bildirim yok — her şey güncel",
  "notifications.empty.desc": "Bekleyen bir sinyal yok. Yeni bir şey olduğunda burada görünür.",
  "notifications.markAll": "Tümünü okundu işaretle",
  "notifications.filtered":
    "bildirim “sadece kritik” tercihiniz nedeniyle gizlendi. Hesap & ayarlar'dan değiştirebilirsiniz.",
  "notifications.markRead": "Okundu işaretle",
  "notifications.markUnread": "Okunmadı işaretle",
  "notifications.unread": "Okunmadı",
  "notifications.critical": "Kritik",
  "notifications.group.critical": "Kritik",
  "notifications.group.normal": "Bildirimler",
  "notifications.type.APPROVAL": "Onay bekliyor",
  "notifications.type.SLA_RISK": "SLA riski",
  "notifications.type.SLA_BREACH": "SLA aşımı",
  "notifications.type.PAID_NOT_ISSUED": "Ödendi, poliçe düzenlenmedi",
  "notifications.type.CUSTOMER_RESPONSE": "Müşteri yanıtladı",
  "notifications.type.HOUSEHOLD_ASSIGNED": "Yeni hane atandı",
  "notifications.type.RENEWAL_FORCED_HIGH": "Yenileme T-7 (yüksek öncelik)",
  // HESAP & AYARLAR — per-staff PERSONAL settings (secondary-surfaces §3).
  "settings.heading": "Hesap & ayarlar",
  "settings.subtitle": "Kişisel tercihleriniz — kendinizle ilgili ayarlar.",
  "settings.loading": "Ayarlar yükleniyor…",
  "settings.error.title": "Ayarlar yüklenemedi",
  "settings.error.detail": "Tercihleriniz alınamadı. Lütfen tekrar deneyin.",
  "settings.retry": "Tekrar dene",
  "settings.save": "Kaydet",
  "settings.saving": "Kaydediliyor…",
  "settings.saved": "Kaydedildi.",
  "settings.profile.title": "Profil",
  "settings.profile.name": "Ad",
  "settings.profile.role": "Rol",
  "settings.profile.email": "E-posta",
  "settings.profile.governed": "Ad ve rol yönetim tarafından belirlenir; burada düzenlenemez.",
  "settings.role.advisor": "Danışman",
  "settings.role.manager": "Ekip yöneticisi",
  "settings.role.admin": "Yönetici",
  "settings.prefs.title": "Tercihler",
  "settings.prefs.locale": "Dil",
  "settings.prefs.locale.hint": "Seçtiğiniz dil hemen uygulanır ve kaydedildiğinde kalıcı olur.",
  "settings.prefs.notifications": "Bildirimler",
  "settings.prefs.criticalOnly": "Yalnızca kritik bildirimler",
  "settings.prefs.criticalOnly.hint": "Açıkken normal öncelikli bildirimler gizlenir.",
  "settings.prefs.accessibility": "Erişilebilirlik",
  "settings.a11y.reducedMotion": "Hareketi azalt",
  "settings.a11y.highContrast": "Yüksek kontrast",
  "settings.a11y.fontScale": "Yazı boyutu",
  "settings.a11y.fontScale.normal": "Normal",
  "settings.a11y.fontScale.large": "Büyük",
  "settings.scope.title": "Kapsam",
  "settings.scope.default": "Varsayılan açılış kapsamı",
  "settings.scope.own": "Kendi",
  "settings.scope.team": "Ekip",
  "settings.scope.hint":
    "Tercihiniz kaydedilir; ancak ekranlar şu an kapsamı yetkinizden türetiyor, bu seçim henüz görünümü değiştirmiyor. Kapsam parametresi eklendiğinde devreye girecek.",
  "settings.security.title": "Güvenlik",
  "settings.security.desc":
    "İki adımlı doğrulama, passkey, oturumlar ve cihazlar hesap konsolunda yönetilir.",
  "settings.security.open": "Hesap konsolunu aç",
  "settings.security.note":
    "Hesap konsolu bağlantısı bu ortamda yapılandırılmamış. Güvenlik ayarları için yöneticinizle görüşün.",
  "settings.media.title": "Fotoğraf ve imza",
  "settings.media.soon": "Yakında",
  "settings.media.desc":
    "Profil fotoğrafınız ve imzanız şifreli saklanır; yalnızca siz erişirsiniz.",
  "settings.media.photo": "Profil fotoğrafı",
  "settings.media.signature": "İmza",
  "settings.media.upload": "Yükle",
  "settings.media.replace": "Değiştir",
  "settings.media.remove": "Kaldır",
  "settings.media.error": "Yüklenemedi. PNG, JPEG veya WEBP; en fazla 2 MB.",
} as const;

export type ConsoleMessageKey = keyof typeof tr;
export type MessageKey = BaseMessageKey | ConsoleMessageKey;
export type Locale = "tr" | "en";

export const en: Record<ConsoleMessageKey, string> = {
  "app.title": "CSA Privé — Advisor Console",
  "shell.brandSub": "Advisor Console",
  "shell.role": "Advisor",
  "nav.section.today": "Today",
  "nav.section.customers": "Customers",
  "nav.section.workflow": "Workflow",
  "nav.section.finance": "Finance & Compliance",
  "nav.section.account": "Account",
  "nav.today": "My Day",
  "nav.queue": "Queue",
  "nav.intake": "New Request",
  "nav.recommendations": "Recommendation",
  "nav.teklif": "Quote Form",
  "nav.households": "My Customers",
  "nav.relationships": "Relationships",
  "nav.book": "My Book",
  // Relationship cockpit (CR-3)
  "rel.heading": "Relationships",
  "rel.subtitle": "A concierge care-CRM — relationship health, not quota.",
  "rel.gov": "No commission · No selling under care-hold · Single relationship owner (ADR 0014)",
  "rel.tab.lifecycle": "Lifecycle",
  "rel.tab.opportunities": "Opportunities",
  "rel.tab.segments": "Segments",
  "rel.tab.tasks": "My Tasks",
  "rel.lc.title": "Care pipeline",
  "rel.lc.note": "Not quota — relationship health. Each household in exactly one stage.",
  "rel.lc.prospect": "Prospect",
  "rel.lc.interested": "Interested",
  "rel.lc.customer": "Customer",
  "rel.lc.renewal": "Renewal",
  "rel.lc.risk": "Risk",
  "rel.lc.empty.title": "No households in your book",
  "rel.lc.empty.desc": "The care pipeline builds here as households arrive.",
  "rel.loading": "Loading…",
  "rel.error.title": "Something went wrong",
  "rel.error.detail": "Could not load the list.",
  "rel.retry": "Try again",
  "rel.reassure": "Nothing in your data changed; you can try again.",
  "rel.opp.empty.title": "No open opportunities",
  "rel.opp.empty.desc": "There are no open opportunities to act on in your book right now.",
  "rel.opp.more": "Load more",
  "rel.opp.type.uninsured": "Uninsured vehicle",
  "rel.opp.type.kasko": "Kasko gap",
  "rel.opp.type.lapsed": "Not renewed",
  "rel.opp.why.uninsured": "A vehicle with no compulsory trafik cover",
  "rel.opp.why.kasko": "Trafik in force, no kasko — value threshold passed",
  "rel.opp.why.lapsed": "A lapsed policy not yet renewed",
  "rel.opp.daysLeft": "days left",
  "rel.opp.prepare": "Prepare offer",
  "rel.opp.defer": "Defer",
  "rel.opp.defer.until": "Defer until",
  "rel.opp.defer.confirm": "Defer",
  "rel.opp.defer.cancel": "Cancel",
  "rel.tab.suppressed": "Held back",
  "rel.sup.intro":
    "Touches the engine held back, and why. Duty-of-care touches are never suppressed.",
  "rel.sup.noConsent": "No consent",
  "rel.sup.careHold": "Care-hold",
  "rel.sup.coolOff": "Cool-off",
  "rel.sup.touchCap": "Touch cap",
  "rel.sup.other": "Held back",
  "rel.sup.empty.title": "Nothing held back",
  "rel.sup.empty.desc": "No touch in your book is currently being withheld.",
  "rel.seg.system.title": "System segments",
  "rel.seg.saved.title": "Saved segments",
  "rel.seg.empty": "No saved segments yet.",
  "rel.seg.count": "households",
  "rel.seg.households.title": "Households",
  "rel.seg.households.empty": "No households from your book in this segment.",
  "rel.seg.households.capped": "households shown — this list is a preview, not the full set.",
  "rel.seg.pick": "Pick a segment on the left to see its households.",
  "rel.task.new.placeholder": "New task (e.g. call Ayşe about renewal)",
  "rel.task.new.note": "Note (optional)",
  "rel.task.add": "Add",
  "rel.task.adding": "Adding…",
  "rel.task.empty.title": "No tasks",
  "rel.task.empty.desc": "Your personal follow-up tasks appear here.",
  "rel.task.done": "Done",
  "rel.task.dismiss": "Dismiss",
  "rel.task.status.open": "Open",
  "rel.task.status.done": "Done",
  "rel.task.status.dismissed": "Dismissed",
  "nav.claims": "Claims",
  "nav.issuance": "Issuance",
  "nav.renewals": "Renewals",
  "nav.reconciliation": "Reconciliation",
  "nav.reports": "Reports",
  "nav.approvals": "Approvals",
  "nav.notifications": "Notifications",
  "nav.settings": "Account & Settings",
  "shell.search.open": "Search (⌘K)",
  "shell.search.placeholder": "Search…",
  "shell.search.customers": "Search customers, policies or pages…",
  "shell.search.hint": "Jump to a page, or press Enter to search customers.",
  "shell.search.empty": "No matching page. Press Enter to search customers.",
  "shell.search.close": "Close",
  "shell.notifications.pending": "Notifications — an item is pending",
  "shell.notifications.unread": "Notifications — unread",
  "shell.notifications.idle": "Notifications — nothing pending",
  "shell.scope.team": "Team view",
  "shell.admin.oversight":
    "Whole-organization view — administrator. Your access is written to the audit log. Power is visibility, not control: off-price issuance and configuration changes remain four-eyes.",
  "shell.admin.consoleLink": "Go to Admin Console",
  "placeholder.preparing": "Getting ready — this surface lands in an upcoming slice.",
  "queue.heading": "Daily Queue",
  "queue.loading": "Loading queue…",
  "queue.empty": "Nothing pending. The queue is clear.",
  "queue.error": "Could not load the queue.",
  "queue.filter.allBands": "All priorities",
  "queue.filter.allTypes": "All types",
  "queue.touch": "household touch",
  "queue.itemsInBundle": "items in this touch",
  "queue.due": "Due",
  "queue.sla": "SLA",
  "queue.suggestion": "Suggestion",
  "queue.claim": "Claim",
  "queue.complete": "Complete",
  "queue.dismiss": "Dismiss",
  "queue.disposition_prompt": "Completion note (outcome):",
  "queue.reason_prompt": "Dismissal reason:",
  "queue.inProgress": "In progress",
  "queue.status.PENDING": "Pending",
  "queue.status.IN_PROGRESS": "In progress",
  "queue.status.DONE": "Completed",
  "queue.status.DISMISSED": "Dismissed",
  "queue.status.SUPPRESSED": "Suppressed",
  "queue.prepareOffers": "3 Teklif Hazırla",
  "band.HIGH": "High",
  "band.MEDIUM": "Medium",
  "band.LOW": "Low",
  "item.RENEWAL": "Renewal due",
  "item.OPPORTUNITY": "Cross-sell opportunity",
  "item.ALERT": "Service alert",
  "item.SERVICE_FOLLOWUP": "Service follow-up",
  "item.NEW_LEAD": "New lead",
  // Inbound-intake leads now land in the queue as NEW_LEAD items — a source-accurate
  // badge (Web / Telefon) + the intake-captured plate label render inline on the row.
  "leads.source.web": "Web",
  "leads.source.phone": "Telefon",
  "leads.plate": "Plate",
  // PREPARE-OFFERS — open a web lead from the queue and author 1–3 offers (package +
  // premium); the server returns a scored DRAFT recommendation and the advisor
  // continues the existing choose→tier2→present flow.
  "po.heading": "3 Teklif Hazırla",
  "po.subheading":
    "Enter 1–3 offers for this web lead. On save a scored recommendation is created and you continue in the existing recommendation flow.",
  "po.line": "Line",
  "po.line.trafik": "Compulsory MTPL",
  "po.line.kasko": "Kasko",
  "po.line.dask": "DASK (Earthquake)",
  "po.line.konut": "Home",
  "po.line.tss": "Complementary Health (TSS)",
  "po.line.oss": "Private Health (OSS)",
  "po.line.seyahat": "Travel",
  "po.catalogFlag":
    "Note: on this surface the package code is entered by hand (lowercase-kebab, e.g. ak-trafik-standart). The carrier is resolved server-side from the code.",
  "po.pkg.loading": "Loading packages…",
  "po.pkg.placeholder": "Select a package…",
  "po.pkg.emptyFallback":
    "No distributable package for this line — enter the package code by hand (e.g. ak-trafik-standart).",
  "po.pkg.errorFallback":
    "Couldn't load the package list — you can enter the package code by hand. Authorization/line checks run server-side.",
  "po.contextUnknownName": "Name not carried",
  "po.packageCode": "Package code",
  "po.packagePlaceholder": "e.g. ak-trafik-standart",
  "po.packageHint":
    "The package code determines the carrier (Carrier — Package). Authorization/line checks run server-side.",
  "po.premium": "Premium (TRY)",
  "po.premiumInvalid": "Premium must be a non-negative decimal (up to 2 places).",
  "po.addOffer": "Add offer",
  "po.removeOffer": "Remove",
  "po.submit": "Prepare & score offers",
  "po.submitting": "Preparing…",
  "po.needOne": "Enter at least one offer (package code + premium).",
  "po.err.lineNeeded": "Line is ambiguous — please choose a line (trafik/kasko).",
  "po.err.assetAmbiguous":
    "More than one insurable asset — this lead couldn't be bound to a single asset.",
  "po.err.noAsset": "No insurable asset found for this customer.",
  "po.err.unsupportedLine": "The recommendation engine supports only trafik/kasko.",
  "po.err.notAuthorized": "This package is not authorized for distribution on this line.",
  "po.err.premium": "Premium is invalid — enter a non-negative amount.",
  "po.err.package": "Package not found or doesn't match this line.",
  "po.reassign.open": "Reassign advisor",
  "po.reassign.title": "Reassign lead",
  "po.reassign.desc": "Hand this lead to an active advisor in your organization.",
  "po.reassign.advisor": "Advisor",
  "po.reassign.choose": "Choose an advisor…",
  "po.reassign.loading": "Loading advisors…",
  "po.reassign.listError": "Couldn't load the advisor list.",
  "po.reassign.empty": "No other advisor available to assign.",
  "po.reassign.cancel": "Cancel",
  "po.reassign.confirm": "Reassign",
  "po.reassign.saving": "Reassigning…",
  "po.reassign.success": "Reassigned to:",
  "po.reassign.owner": "New owner",
  // CUSTOMER → QUOTE FORM — an advisor-operated, in-console 3-step wizard
  // (Details → Offers → Advisor). The customer arrived off any channel (NOT a
  // self-serve web form). Step 1 reuses the phone-intake capture chain; Step 2
  // reuses the existing prepare-offers contract.
  "qf.heading": "Customer → Quote Form",
  "qf.subheading":
    "Capture a customer who arrived off any channel and build 1–3 offers. Everything is recorded; you finish in the recommendation flow.",
  "qf.restricted":
    "This flow requires lead:write, party:write, capture:write and recommendation:write.",
  "qf.step1": "Details",
  "qf.step2": "Offers",
  "qf.step3": "Advisor",
  "qf.section.product": "Product & channel",
  "qf.line": "Line",
  "qf.line.trafik": "Compulsory MTPL",
  "qf.line.kasko": "Kasko",
  "qf.channel": "Where did they come from? (channel)",
  "qf.channel.PHONE": "Phone",
  "qf.channel.EMAIL": "Email",
  "qf.channel.WHATSAPP": "WhatsApp",
  "qf.channel.IN_PERSON": "In person",
  "qf.channelHint": "The channel the customer reached us on is recorded on the interaction.",
  "qf.section.customer": "Customer details",
  "qf.firstName": "First name",
  "qf.lastName": "Last name",
  "qf.tckn": "National ID (TCKN)",
  "qf.phone": "Mobile phone",
  "qf.email": "Email (optional)",
  "qf.section.vehicle": "Vehicle details",
  "qf.plate": "Plate (optional)",
  "qf.plateHint": "e.g. 34 ABC 123 — leave blank if not to hand; if entered it must be valid.",
  "qf.plateInvalid": "Invalid plate format (e.g. 34 ABC 123).",
  "qf.make": "Make (optional)",
  "qf.model": "Model (optional)",
  "qf.section.consent": "Consent (legal record)",
  "qf.noticeRef": "The privacy notice was shared with the customer and consent captured.",
  "qf.serviceAttest": "The privacy notice was read and the customer consented to service contact.",
  "qf.marketingAttest": "The customer also consented to marketing contact (optional).",
  "qf.iysNote": "Marketing consent is logged, but no İYS message is sent during the pilot.",
  "qf.continue": "Continue",
  "qf.step1Locked":
    "This step is saved (the customer, household and request were created). If a detail needs correcting, do it on the customer record — changes here are not saved.",
  "qf.back": "Back",
  "qf.saving": "Saving…",
  "qf.captureError": "Could not create the record. Please try again.",
  "qf.dedup": "A customer with this phone or national ID already exists.",
  "qf.dedupSearch": "Search for the existing customer →",
  "qf.assetError":
    "The customer and lead were created, but the vehicle could not be saved — try again later.",
  "qf.offersTitle": "Offers (1–3)",
  "qf.doneBadge": "Created",
  "qf.summaryTitle": "Record complete",
  "qf.summaryCustomer": "Customer",
  "qf.summaryOffers": "Offers created",
  "qf.leadRef": "Lead reference",
  "qf.goToRecommendation": "Go to recommendation",
  "qf.line.dask": "DASK (Compulsory Earthquake)",
  "qf.line.seyahat": "Travel Health",
  "qf.line.saglik": "Health (TSS/ÖSS)",
  "qf.channel.INTERNET_AD": "Internet ad",
  "qf.channel.INSTAGRAM": "Instagram",
  "qf.channel.OTHER": "Other",
  "qf.channelOther": "Channel detail (Other)",
  "qf.channelOtherPlaceholder": "e.g. referral, trade fair…",
  "qf.modeLabel": "Customer type",
  "qf.mode.new": "New member",
  "qf.mode.registered": "Registered member",
  "qf.reg.title": "Find a registered member",
  "qf.reg.searchLabel": "Search by name or phone",
  "qf.reg.placeholder": "Name or phone…",
  "qf.reg.go": "Search",
  "qf.reg.loading": "Searching…",
  "qf.reg.none": "No matching record found.",
  "qf.reg.select": "Select",
  "qf.reg.noHousehold": "No household",
  "qf.reg.change": "Change",
  "qf.reg.attach": "Will attach to the existing record",
  "qf.reg.note":
    "A new offer is prepared for the selected member; the party is not re-created (the existing party/household is reused).",
  "qf.reg.masked": "—",
  "qf.reg.noPhone": "Phone not returned by search",
  "qf.reg.tcknFlag": "National ID is masked/not returned by search; not needed for the offer.",
  "qf.reg.emailFlag": "Email is not returned by search.",
  "qf.dedupRegistered": "Continue as registered member",
  "rec.heading": "Recommendations",
  "rec.create": "New recommendation",
  "rec.householdId": "Household id",
  "rec.lineCode": "Line",
  "rec.mustHaves": "Must-haves",
  "rec.priorities": "Priorities",
  "rec.budget": "Budget posture",
  "rec.start": "Start recommendation",
  // Öneri (needs assessment) redesign — picker + chips + segmented stance.
  "rec.needs.subtitle": "Needs assessment — start the recommendation",
  "rec.needs.suggestTitle": "This step only captures the need",
  "rec.needs.suggestBody":
    "No score or price is computed here — the system computes and suggests server-side; you decide.",
  "rec.household.label": "Household",
  "rec.household.hint":
    "Pick the household this recommendation is for (only customers assigned to you).",
  "rec.household.search": "Search household (name or phone)",
  "rec.household.placeholder": "Search by name or phone…",
  "rec.household.go": "Search",
  "rec.household.loading": "Searching…",
  "rec.household.none": "No matching household found.",
  "rec.household.select": "Select",
  "rec.household.change": "Change",
  "rec.household.noHousehold": "No household",
  "rec.line.hint":
    "Branches come from the catalog and the panel authorisation; closed ones show why.",
  "rec.asset.label": "Insured asset",
  "rec.asset.hint":
    "Issuance requires an asset; the household's assets for this line are listed here.",
  "rec.asset.loading": "Loading assets…",
  "rec.asset.error": "Could not read the household's assets. Refresh and try again.",
  "rec.asset.none":
    "This household has no registered asset for this line. You can still create the recommendation, but without an asset it CANNOT be issued. Register the asset in the Quote Form.",
  "rec.asset.toQuoteForm": "Go to the Quote Form",
  "rec.asset.required": "Select an asset to continue.",
  "rec.line.trafik": "Trafik",
  "rec.line.kasko": "Kasko",
  "rec.line.dask": "DASK",
  "rec.line.konut": "Home",
  "rec.line.tss": "TSS",
  "rec.line.oss": "OSS",
  "rec.line.seyahat": "Travel",
  "rec.line.closed": "Next slice",
  "rec.line.closedWhy": "Only the branches the panel is authorised for are open in the pilot.",
  "rec.mustHaves.hint": "Pick the coverages that must be met from the canonical list (hard-gate).",
  "rec.priorities.hint":
    "Important but not mandatory coverages — they softly influence the ranking.",
  "rec.concepts.locked": "Reading the coverage list needs catalog read permission.",
  "rec.concepts.loading": "Loading coverages…",
  "rec.concepts.none": "No coverage concepts defined for this line.",
  "rec.budget.hint": "The customer's budget posture — the server weighs price-value accordingly.",
  "rec.budget.cheapest": "Cheapest",
  "rec.budget.balanced": "Balanced",
  "rec.budget.bestProtection": "Best protection",
  "rec.loading": "Loading recommendation…",
  "rec.error": "Could not load the recommendation.",
  "rec.comp.needsFit": "Needs Fit",
  "rec.comp.carrierQuality": "Carrier Quality",
  "rec.comp.coverageQuality": "Coverage vs Needs",
  "rec.comp.priceValue": "Price Value",
  "rec.suitability": "Suitability",
  "rec.suggestion": "Suggested",
  "rec.chosen": "Chosen",
  "rec.premium": "Premium",
  "rec.citation": "Citation",
  "rec.qualitySnapshot": "quality snapshot",
  "rec.equivVersion": "equivalence version",
  "rec.hardGate": "Unmet must-have",
  "rec.offerEntry": "Offer entry",
  "rec.offerId": "Offer id",
  "rec.offerIdHint":
    "The ids of the offer records created by the Quote Form / 3-offer flow. One per line if there are several. (No offer picker at this step — there is no offer-list read keyed to this recommendation.)",
  "rec.addOffer": "Add offer",
  "rec.score": "Score",
  "rec.choose": "Choose",
  "rec.confirmChoice": "Confirm choice",
  "rec.reasonCode": "Reason code",
  "rec.rationale": "Cheaper-but rationale",
  "rec.rationaleRequired": "A non-cheapest offer requires a rationale.",
  "rec.advisorNote": "Note to the customer (optional)",
  "rec.advisorNoteHint":
    "Shown to the customer and recorded — do not write special/health information.",
  "rec.advisorNoteCounter": "Character count",
  "rec.status": "Status",
  "rec.pendingTier2": "Awaiting a second approval (Tier-2)",
  "rec.tier2.requestApproval": "Request approval",
  "rec.tier2.awaiting": "Awaiting approval…",
  "rec.tier2.approved": "Approved — complete the Tier-2 review",
  "rec.tier2.complete": "Complete Tier-2 review",
  "rec.tier2.grant": "Grant approval",
  "rec.tier2.decline": "Decline",
  "rec.tier2.declineReason": "Decline reason:",
  "rec.tier2.noApproval": "No pending approval for this recommendation.",
  "rec.tier2.selfHint": "You cannot approve your own request (a second person is required).",
  "rec.present": "Presented to the customer — record the decision",
  "rec.decision": "Customer decision",
  "rec.accepted": "Accept",
  "rec.declined": "Decline",
  "rec.deferred": "Defer",
  "rec.declineReason": "Decline reason",
  "rec.decided": "Decision recorded",
  "rec.issue": "Issue policy",
  "rec.issueNoAsset": "This recommendation has no insured asset — issuance requires one.",
  "rec.delivery.title": "Send the proposal",
  "rec.delivery.pdf": "Download proposal PDF",
  "rec.delivery.pdfLoading": "Preparing PDF…",
  "rec.delivery.pdfError": "Couldn't fetch the PDF — please try again.",
  "rec.delivery.link": "Create WhatsApp link → copy",
  "rec.delivery.linkLoading": "Creating link…",
  "rec.delivery.linkError": "Couldn't create the link — please try again.",
  "rec.delivery.copied": "Link copied — paste it into WhatsApp.",
  "rec.delivery.copyManual": "Link ready — copy it below (clipboard unavailable).",
  "rec.delivery.expiry": "This link is valid for 7 days.",
  "rec.customerResponse.heading": "Customer response",
  "rec.customerResponse.said": "Customer",
  "rec.customerResponse.history": "Earlier responses",
  "rec.response.ACCEPTED": "accepted",
  "rec.response.DECLINED": "declined",
  "rec.response.DEFERRED": "deferred",
  "rec.pending.heading": "Responses awaiting you",
  "rec.pending.empty": "No customer responses awaiting you.",
  "hh.heading": "Customer 360",
  "hh.householdId": "Household id",
  "hh.open": "Open",
  "hh.search.label": "Search by phone or name",
  "hh.search.placeholder": "+9055… or Ayşe",
  "hh.search.go": "Search",
  "hh.search.byPhone": "Searching by phone",
  "hh.search.byName": "Searching by name",
  "hh.search.loading": "Searching…",
  "hh.search.none": "No results.",
  "hh.search.noHousehold": "household link pending",
  "hh.list.title": "Customers",
  "hh.list.loading": "Loading customers…",
  "hh.list.empty": "No customers yet.",
  "hh.list.error": "Couldn't load the customer list.",
  "hh.list.more": "Load more",
  "hh.advanced": "Advanced — open by id",
  // Müşterilerim — the advisor's own book (default view + server-side filter tabs).
  "hh.book.tabsLabel": "Household filters",
  "hh.book.tab.mine": "My households",
  "hh.book.tab.actionPending": "Action pending",
  "hh.book.tab.careHold": "Care-hold",
  "hh.book.count": "households",
  "hh.book.loading": "Loading your book…",
  "hh.book.error": "Couldn't load your book.",
  "hh.book.empty": "No households in this filter.",
  "hh.book.members": "members",
  "hh.book.policies": "policies",
  "hh.book.renewalDue": "⟳ Renewal approaching",
  "hh.book.careHold": "⚑ sales muted",
  "hh.book.nextAction": "Next action",
  "hh.book.na.renewal": "Renewal approaching",
  "hh.book.na.quote": "Quote awaiting",
  "hh.book.na.lead": "New lead",
  "hh.book.na.claim": "Claim follow-up",
  "hh.book.na.alert": "Alert to review",
  "hh.book.na.service": "Service follow-up",
  "hh.polStatus.ACTIVE": "Active",
  "hh.polStatus.CANCELLATION_REQUESTED": "Cancellation requested",
  "hh.polStatus.CANCELLED": "Cancelled",
  "hh.polStatus.RENEWED": "Renewed",
  "hh.polStatus.EXPIRED": "Expired",
  "hh.loading": "Loading household…",
  "hh.error": "Could not load the household.",
  "hh.owner": "Relationship owner",
  "hh.since": "since",
  "hh.members": "Members",
  "hh.policies": "In-force policies",
  "hh.engagement": "Engagement log",
  "hh.lifeEvents": "Life events",
  "hh.tl.title": "Timeline",
  "hh.tl.interaction": "Interaction",
  "hh.tl.lifeEvent": "Life event",
  "hh.tl.recommendation": "Recommendation",
  "hh.tl.claim": "Claim",
  "hh.tl.policy": "Policy",
  "hh.tl.care": "Care — no selling",
  "hh.consent": "Consent state",
  "hh.crossLinks": "Links",
  "hh.none": "Nothing recorded.",
  "hh.careHold": "CARE — sales suppressed",
  "hh.term": "Term",
  "hh.marketingOk": "Marketing consent on file",
  "hh.consentWithdraw": "Withdraw consent",
  "hh.consentWithdrawYes": "Yes, withdraw",
  "hh.consentWithdrawNo": "Cancel",
  "hh.consentWithdrawConfirm":
    "This person's marketing consent will be withdrawn and they will be excluded from marketing contact. Only the customer themselves can grant it again. Continue?",
  "hh.marketingNo": "No marketing consent",
  "hh.tckn.show": "Show TCKN",
  "hh.tckn.hide": "Hide",
  "hh.tckn.loading": "Revealing…",
  "hh.tckn.error": "Couldn't reveal the TCKN — please try again.",
  "pol.loading": "Loading policy…",
  "pol.error": "Couldn't load the policy.",
  "pol.heading": "Policy",
  "pol.status": "Status",
  "pol.term": "Term",
  "pol.endorse.title": "Endorsement",
  "pol.endorse.note": "Change note",
  "pol.endorse.add": "Add endorsement",
  "pol.endorse.created": "Endorsement created",
  "pol.endorse.effect": "Effect",
  "pol.endorse.effected": "Effected",
  "pol.endorse.noEffect": "Effecting requires the application:issue grant.",
  "pol.endorse.inactive": "An endorsement can only be added on an active policy.",
  "pol.cancel.title": "Cancellation",
  "pol.cancel.subtype": "Cancellation type",
  "pol.cancel.subtype.CUSTOMER": "Customer request",
  "pol.cancel.subtype.CARRIER_NONPAYMENT": "Carrier non-payment",
  "pol.cancel.subtype.CSA": "CSA (four-eyes)",
  "pol.cancel.reason": "Reason",
  "pol.cancel.request": "Cancel policy",
  "pol.cancel.requested": "Cancellation requested",
  "pol.cancel.returnPremium": "Return premium (if any)",
  "pol.cancel.confirm": "Confirm cancellation",
  "pol.cancel.done": "Policy cancelled",
  "pol.cancel.notApplicable": "Cancellation does not apply in this policy status.",
  "pol.cancel.returned": "Return premium:",
  "hh.links.recommendations": "Recommendations",
  "hh.rec.item": "Recommendation",
  "hh.opportunities": "Opportunities",
  "hh.renewal": "Renewal",
  "hh.commission": "Commission",
  "hh.gap": "Gap",
  "hh.panelError": "Failed to load.",
  "hh.oppType.UNINSURED_VEHICLE": "Uninsured vehicle",
  "hh.oppType.KASKO_GAP": "Kasko gap",
  "hh.oppType.LAPSED_NOT_RENEWED": "Lapsed, not renewed",
  "hh.eventType.NEW_VEHICLE": "New vehicle",
  "hh.eventType.CHILD_BIRTH": "Child birth",
  "hh.eventType.NEW_DEPENDENT": "New dependent",
  "hh.eventType.HOME_PURCHASE": "Home purchase",
  "hh.eventType.MARRIAGE": "Marriage",
  "hh.eventType.BEREAVEMENT": "Bereavement",
  "hh.eventType.ILLNESS": "Illness",
  "hh.eventType.INJURY": "Injury",
  "hh.eventType": "Event type",
  "hh.engage.touches": "Cross-sell touches (30d)",
  "hh.engage.lastContact": "Last contact",
  "hh.markActioned": "Mark actioned",
  "hh.addLifeEvent": "Add",
  "hh.ownershipActions": "Ownership actions",
  "hh.reassign.title": "Reassign owner",
  "hh.reassign.toAdvisor": "New advisor id",
  "hh.reassign.reason": "Reason",
  "hh.reassign.submit": "Reassign",
  "hh.participation.title": "Record participation",
  "hh.participation.function": "Function",
  "hh.participation.context": "Task context",
  "hh.participation.submit": "Record participation",
  "hh.participation.ok": "Participation recorded.",
  "book.title": "My household book",
  "book.loading": "Loading…",
  "book.error": "Could not load your book.",
  "book.empty": "No households assigned to you yet.",
  "book.since": "since",
  "hh.links.claims": "Claims",
  "hh.links.queue": "Queue",
  "hh.log.heading": "Log an interaction",
  "hh.log.channel": "Channel",
  "hh.log.direction": "Direction",
  "hh.log.intent": "Intent",
  "hh.log.consent": "Consent state",
  "hh.log.submit": "Log",
  "hh.log.marketingHint":
    "Marketing intent: with no consent it's logged as an opportunity (no contact).",
  "hh.log.logged": "Interaction logged.",
  "claims.heading": "Claims Desk",
  "claims.loading": "Loading claims…",
  "claims.error": "Could not load claims.",
  "claims.none": "No open claims.",
  "claims.careMode":
    "Care mode: for households with an open claim, sales signals are suppressed. There are no recommendation actions on this screen — only follow-up and updates.",
  "claims.status": "Status",
  "claims.line": "Line",
  "claims.carrier": "Carrier",
  "claims.loss": "Loss date",
  "claims.versionAtLoss": "Version-in-force at loss",
  "claims.outcome": "Outcome",
  "claims.injury": "Bodily injury",
  "claims.thirdParty": "Third party",
  "claims.timeline": "Advocacy timeline",
  "claims.advance": "Advance",
  "claims.carrierRefPrompt": "Carrier claim reference:",
  "claims.fnol.heading": "File a claim (FNOL)",
  "claims.fnol.policyId": "Policy id",
  "claims.fnol.lossAt": "Loss date/time",
  "claims.fnol.bodilyInjury": "Involves bodily injury",
  "claims.fnol.thirdParty": "Has a third party",
  "claims.fnol.careWarning":
    "Bodily injury trips a CARE hold — sales are suppressed for this household during the claim.",
  "claims.fnol.file": "Open claim",
  "claims.event.heading": "Append to the log",
  "claims.event.type": "Type",
  "claims.event.note": "Note (non-sensitive)",
  "claims.event.add": "Append",
  "claims.resolve.heading": "Resolve",
  "claims.resolve.outcome": "Outcome",
  "claims.resolve.amount": "Amount (carrier-reported)",
  "claims.resolve.satisfaction": "Satisfaction (1–5)",
  "claims.resolve.resolve": "Resolve",
  "claims.resolve.withdraw": "Withdraw",
  "claims.resolve.amountRequired":
    "Paid / partially paid requires a carrier-reported amount greater than 0.",
  "claims.resolve.rejectedNoAmount": "A rejected claim takes no amount — leave it blank.",
  "claims.resolve.needsInProgress":
    "Recording an outcome requires the claim to be In progress (the carrier has not responded yet). A claim opened in error can still be withdrawn below.",
  "claims.resolve.reason": "Withdrawal reason",
  "recon.heading": "Reconciliation",
  "recon.loading": "Loading…",
  "recon.error": "Could not load reconciliation.",
  "recon.totals": "Totals",
  "recon.expected": "Expected",
  "recon.received": "Received",
  "recon.gap": "Gap",
  "recon.byCarrier": "By carrier",
  "recon.entries": "entries",
  "recon.exceptions": "Exceptions",
  "recon.variances": "Variances",
  "recon.disputed": "Disputed",
  "recon.clawedBack": "Clawed back",
  "recon.unmatched": "Unmatched lines",
  "recon.missingRate": "Missing-rate backlog",
  // Exception-class labels (the API enum VALUES are unchanged — display + tooltip only).
  "recon.status.EXPECTED": "Expected",
  "recon.status.RECONCILED": "Reconciled",
  "recon.status.VARIANCE": "Variance",
  "recon.status.DISPUTED": "Disputed",
  "recon.status.CLAWED_BACK": "Clawed back",
  "recon.status.UNMATCHED": "Unmatched",
  "recon.status.MISSING_RATE": "Missing rate",
  "recon.statusHelp.EXPECTED": "Commission we expect to receive but that has not been paid yet.",
  "recon.statusHelp.RECONCILED": "Expected and received amounts matched.",
  "recon.statusHelp.VARIANCE":
    "The paid amount differs from what was expected — outside tolerance.",
  "recon.statusHelp.DISPUTED": "A dispute was opened with the carrier over the difference.",
  "recon.statusHelp.CLAWED_BACK": "Commission the carrier has clawed back.",
  "recon.statusHelp.UNMATCHED": "This statement line did not match any expected entry.",
  "recon.statusHelp.MISSING_RATE":
    "No commission rate is defined — the expected amount can't be computed.",
  "recon.none": "Nothing here.",
  "recon.dispute.open": "Open dispute",
  "recon.dispute.resolve": "Resolve",
  "recon.dispute.reasonPrompt": "Dispute reason:",
  "recon.actionFailed": "Not recorded. The entry is unchanged.",
  "recon.dispute.resolvedReconciled": "Resolve → Reconciled",
  "recon.dispute.resolvedVariance": "Resolve → Variance",
  "recon.stmt.heading": "Statement entry",
  "recon.stmt.carrierId": "Carrier id",
  "recon.stmt.periodStart": "Period start",
  "recon.stmt.periodEnd": "Period end",
  "recon.stmt.total": "Statement total",
  "recon.stmt.ref": "Policy reference",
  "recon.stmt.lineType": "Type",
  "recon.stmt.amount": "Amount",
  "recon.stmt.addLine": "Add line",
  "recon.stmt.submit": "Submit statement",
  "recon.stmt.incomplete": "Carrier, period start/end and the statement total are required.",
  "recon.bulk.heading": "Bulk statement entry",
  "recon.bulk.coveredRefs": "Covered policy references (comma/newline)",
  "recon.bulk.submit": "Submit bulk statement",
  "recon.bulk.incomplete":
    "Carrier, period, total and at least one carrier reference are required.",
  "recon.bulk.result": "Allocation result (estimated proportional)",
  "recon.bulk.estimatedNote": "Amounts allocated proportionally to Expected (is_estimated).",
  "inbox.heading": "Approver Inbox",
  "inbox.loading": "Loading…",
  "inbox.none": "No pending approvals.",
  "inbox.action": "Action",
  "inbox.resource": "Resource",
  "inbox.requester": "Requested by",
  "inbox.approve": "Approve",
  "inbox.reject": "Reject",
  "inbox.rejectReason": "Rejection reason (required):",
  "inbox.rejectConfirm": "Confirm rejection",
  "inbox.actionFailed": "The approval could not be recorded. No decision was made.",
  "common.offline": "No connection. The request never reached the server.",
  "iss.actionFailed": "The action was not recorded. The policy state is unchanged.",
  "hh.actionFailed": "Not saved. The change was not applied.",
  "q.actionFailed": "Not recorded. The queue item is unchanged.",
  "queue.promptUnavailable":
    "This browser cannot show the required prompt, so nothing was submitted.",
  "cl.actionFailed": "Not recorded. The claim is unchanged.",
  "rec.actionFailed": "Not recorded. The recommendation is unchanged.",
  "crm.actionFailed": "The action could not be recorded.",
  "crm.loadFailed": "The list could not be read. This does NOT mean there are none.",
  "inbox.review": "Review",
  "inbox.noReview": "No review surface for this action",
  "inbox.tabs.label": "Approval lists",
  "inbox.tab.awaiting": "Awaiting me",
  "inbox.tab.sent": "Sent by me",
  "inbox.sent.none": "You haven't sent any approval requests yet.",
  "inbox.status.PENDING": "Pending",
  "inbox.status.APPROVED": "Approved",
  "inbox.status.REJECTED": "Rejected",
  "inbox.status.CONSUMED": "Consumed",

  // B5 — issuance desk
  "iss.heading": "Issuance Desk",
  "iss.restricted": "You don't have permission to view this desk.",
  "iss.exceptionsWaiting": "Exceptions waiting",
  "df.today": "Today",
  "df.now": "Now",
  "iss.loading": "Loading…",
  "iss.error": "Could not load applications.",
  "iss.empty": "No open applications.",
  "iss.detailHeading": "Policy application",
  "iss.acceptedPrice": "Accepted premium",
  "iss.issuedPrice": "Issued premium",
  "iss.issuedPremium": "Issued premium",
  "iss.line": "Product",
  "iss.carrier": "Carrier",
  "iss.line.trafik": "Compulsory MTPL",
  "iss.line.kasko": "Kasko",
  "iss.status.DRAFT": "Draft",
  "iss.status.SUBMITTED_TO_CARRIER": "Submitted to carrier",
  "iss.status.ISSUANCE_PENDING": "Issuance pending",
  "iss.status.ISSUED": "Issued",
  "iss.status.ISSUANCE_EXCEPTION": "Exception",
  "iss.status.QUOTE_REVALIDATION": "Quote revalidation",
  "iss.status.WITHDRAWN": "Withdrawn",
  "iss.status.DECLINED": "Declined",
  "iss.status.FAILED": "Failed",
  "iss.exception.PRICE_INTEGRITY_FAIL": "Price-integrity mismatch",
  "iss.exception.ISSUED_UNCONFIRMED": "Issued, unconfirmed",
  "iss.exception.PAID_NOT_ISSUED": "Paid, not issued",
  "iss.stage.submit": "Submit to carrier",
  "iss.stage.submitHint": "Submit the application to the carrier (quote validity is checked).",
  "iss.action.submit": "Submit",
  "iss.stage.revalidate": "Re-quote",
  "iss.stage.revalidateHint":
    "The quote validity lapsed. To continue, enter the NEW offer obtained from the carrier — price integrity is checked against it.",
  "iss.revalidate.offerId": "New offer reference",
  "iss.revalidate.offerIdHint":
    "The id of the offer record created by the carrier's re-quote. (There is no offer-list read on an application — a picker is backlog.)",
  "iss.revalidate.acceptedAt": "Accepted at",
  "iss.revalidate.validUntil": "Valid until",
  "iss.action.revalidate": "Attach the new offer",
  "iss.stage.terminate": "Close the application",
  "iss.stage.terminateHint":
    "Close this application if it will not become a policy. “Withdrawn” = we stopped; “Carrier declined” = the carrier refused. They are recorded separately; the carrier-quality measurement reads the difference.",
  "iss.terminate.reason": "Reason",
  "iss.action.withdraw": "Withdrawn",
  "iss.action.recordDeclined": "Carrier declined",
  "iss.stage.observe": "Payment observation",
  "iss.stage.observeHint":
    "Observe and record that the customer paid the carrier. CSA holds no money; the payment goes directly to the carrier.",
  "iss.paymentReference": "Payment reference (carrier side)",
  "iss.action.observe": "Record observation",
  "iss.stage.confirm": "Confirm issuance",
  "iss.gate.rule":
    "The issued premium must equal the accepted premium and a proof reference is required; otherwise an exception is raised",
  "iss.carrierPolicyNumber": "Carrier policy number",
  "iss.proofRef": "Proof reference",
  "iss.proofN6Flag":
    "Document upload arrives with N6 (Documents) — for now proof is entered as a reference/id.",
  "iss.action.confirm": "Confirm issuance",
  "iss.issuedBadge": "Active policy",
  "iss.issuedBody": "The policy was issued — an active policy was created.",
  "iss.policyRef": "Policy reference",
  "iss.exceptionHeading": "Exception",
  "iss.statusField": "Status",
  "iss.exceptionTypeField": "Exception type",
  "iss.exceptionExplain.PRICE_INTEGRITY_FAIL":
    "The issued premium did not match the accepted premium. The policy was not auto-activated.",
  "iss.exceptionExplain.ISSUED_UNCONFIRMED":
    "The policy was issued but could not be confirmed without a proof reference.",
  "iss.exceptionExplain.PAID_NOT_ISSUED":
    "The customer paid the carrier but no policy has issued yet. Highest-priority case — act immediately.",
  "iss.offPriceFourEyes":
    "Proceeding off-price requires four-eyes approval — no single actor can pass it.",
  "iss.resolveReason": "Reason",
  "iss.action.retry": "Retry",
  "iss.action.fail": "Mark failed",
  "iss.needWrite": "This action requires the application:write permission.",
  "iss.needIssue": "Issuance requires the application:issue permission.",

  // B0 — phone lead-intake
  "intake.heading": "Phone Lead Intake",
  "intake.subheading":
    "Record the caller on the call and capture their verbal consent. No price/offer is given.",
  "intake.restricted":
    "This action requires the lead:write, party:write and capture:write permissions.",
  "intake.callerSection": "Caller details",
  "intake.firstName": "First name",
  "intake.lastName": "Last name",
  "intake.phone": "Phone",
  "intake.email": "Email (optional)",
  "intake.tckn": "National ID (TCKN)",
  "intake.birthDate": "Date of birth (optional)",
  "intake.il": "Province (optional)",
  "intake.ilce": "District (optional)",
  "intake.meslek": "Occupation (optional)",
  "intake.commonCaptureNote":
    "Date of birth and province/district are captured for now; they persist once the backend contract lands (backend-first).",
  "intake.productSection": "Product interest",
  "intake.line": "Product",
  "intake.line.trafik": "Compulsory MTPL",
  "intake.line.kasko": "Kasko",
  "intake.line.dask": "DASK (Compulsory Earthquake)",
  "intake.line.seyahat": "Travel Health",
  "intake.line.saglik": "Health (TSS/ÖSS)",
  "intake.selectPlaceholder": "Select…",
  "intake.notes": "Note (optional)",
  "intake.noPriceNote": "No price or offer at this step — the offer is prepared later.",
  "intake.vehicleSection": "Vehicle details",
  "intake.plate": "Plate (optional)",
  "intake.plateHint": "e.g. 34 ABC 123 — leave blank if not to hand; if entered it must be valid.",
  "intake.plateInvalid": "Invalid plate format (e.g. 34 ABC 123).",
  "intake.make": "Make (optional)",
  "intake.model": "Model (optional)",
  "intake.vin": "Chassis / VIN (optional)",
  "intake.vinHint": "17-character chassis number; optional.",
  "intake.vinInvalid": "VIN must be 17 characters.",
  "intake.ruhsat": "Registration (ruhsat) serial no (optional)",
  "intake.ehliyetDate": "Licence issue date (optional)",

  // DASK — dwelling (canonical §3)
  "intake.dwellingSection": "Dwelling details (DASK)",
  "intake.address": "Full address (optional)",
  "intake.uavt": "UAVT address code (optional)",
  "intake.uavtHint":
    "10-digit UAVT address code — from e-Devlet; if entered it is written to the DASK asset.",
  "intake.uavtInvalid": "UAVT address code must be 10 digits.",
  "intake.brutM2": "Gross m² (optional)",
  "intake.yapiTarzi": "Construction type (optional)",
  "intake.yapiTarzi.betonarme": "Reinforced concrete",
  "intake.yapiTarzi.celik": "Steel",
  "intake.yapiTarzi.yigma": "Masonry",
  "intake.yapiTarzi.diger": "Other",
  "intake.insaYili": "Construction year (optional)",
  "intake.kat": "Floor (optional)",
  "intake.dwellingCaptureNote":
    "m² / construction type / year / floor are captured for now; they persist once the contract lands (backend-first).",
  // Travel (canonical §4)
  "intake.travelSection": "Travel details",
  "intake.travelDestination": "Destination country / region (optional)",
  "intake.travelStart": "Start date (optional)",
  "intake.travelEnd": "End date (optional)",
  "intake.travelers": "Number of travellers (optional)",
  "intake.travelCaptureNote":
    "Travel fields are captured for now; they persist once the contract lands (backend-first).",
  // Health (canonical §5) — SGK + hospital only; NO health declaration (special-category, offline)
  "intake.healthSection": "Health details",
  "intake.sgkStatus": "SGK status (optional)",
  "intake.sgk.sgkli": "Has SGK",
  "intake.sgk.sgksiz": "No SGK",
  "intake.sgk.bilinmiyor": "Unknown",
  "intake.hospitalPref": "Coverage / preferred hospital network (optional)",
  "intake.healthOfflineNote":
    "No health declaration is taken here — special-category data is kept offline until go-live. SGK/hospital fields are captured for now (backend-first).",
  "intake.consentSection": "Verbal consent (legal record)",
  "intake.noticeRef": "Privacy notice read on the call",
  "intake.noticeVersionLabel": "Version",
  "intake.serviceAttest":
    "The privacy notice was read and the caller verbally consented to service contact.",
  "intake.marketingAttest": "The caller also verbally consented to marketing contact (optional).",
  "intake.healthAttest":
    "The caller gave a SEPARATE explicit consent to processing health data (special-category).",
  "intake.healthConsentNote":
    "Health consent is a separate permission; captured for now but persists once the special-category consent contract lands (backend-first).",
  "intake.iysNote": "Marketing consent is logged, but no İYS message is sent during the pilot.",
  "intake.error": "Could not create the record. Please try again.",
  "intake.dedup": "A customer with this phone or national ID already exists.",
  "intake.dedupSearch": "Search for the existing customer →",
  "intake.submit": "Create lead",
  "intake.doneBadge": "Created",
  "intake.doneTitle": "Lead created",
  "intake.doneBody": "The caller entered the funnel; the recommendation flow can pick it up.",
  "intake.leadRef": "Lead reference",
  "intake.another": "New intake",

  // BUGÜN — Günüm ("My Day") dashboard. Calm, no commission, no forecast; every zero
  // renders as an honest empty state (never a fabricated number).
  "gunum.heading": "My Day",
  "gunum.subtitle": "Your day, at a glance.",
  "gunum.loading": "Preparing your day…",
  "gunum.error.title": "The dashboard couldn't load right now",
  "gunum.error.detail": "Could not load the My Day dashboard.",
  "gunum.error.reassure": "Your queue is unaffected — your work is intact.",
  "gunum.retry": "Retry",
  "gunum.empty.title": "Data is accruing",
  "gunum.empty.desc": "This fills in with your first customers.",
  "gunum.scopeHint": "Myself ↔ My team",
  "gunum.scope.group": "Scope selection",
  "gunum.scope.own": "Myself",
  "gunum.scope.team": "Scope: my team",
  "gunum.scope.all": "Scope: whole book",
  // (1) Capacity & queue
  "gunum.cap.title": "Capacity & queue",
  "gunum.cap.totalLabel": "items today",
  "gunum.cap.utilization": "capacity used",
  "gunum.cap.healthy": "Capacity healthy",
  "gunum.cap.tight": "Capacity nearly full",
  "gunum.cap.empty": "Nothing open today — the queue is clear.",
  "gunum.cap.link": "Go to queue",
  // (2) SLA health
  "gunum.sla.title": "SLA health",
  "gunum.sla.onTime": "On time",
  "gunum.sla.atRisk": "At risk",
  "gunum.sla.breached": "Breached",
  "gunum.sla.trend": "Last 7 days",
  "gunum.sla.trendAria": "Trend of open SLA-bearing items over the last 7 days:",
  "gunum.sla.trendUp": "rising",
  "gunum.sla.trendDown": "falling",
  "gunum.sla.trendFlat": "flat",
  "gunum.sla.empty": "No open SLA-bearing items.",
  "gunum.sla.link": "Go to queue",
  // (3) Portfolio depth
  "gunum.depth.title": "Portfolio depth",
  "gunum.depth.households": "households",
  "gunum.depth.activePolicies": "active policies",
  "gunum.depth.perHousehold": "policies per household",
  "gunum.depth.median": "median",
  "gunum.depth.range": "policy range",
  "gunum.depth.service":
    "Depth is a service signal — shallow households are ones to care for, not a sales target.",
  "gunum.depth.empty": "No households yet.",
  "gunum.depth.link": "Go to customers",
  // (4) Renewal pipeline
  "gunum.renew.title": "Renewal pipeline",
  "gunum.renew.t45": "T-45",
  "gunum.renew.t7": "T-7",
  "gunum.renew.expiry": "Expired",
  "gunum.renew.empty": "No active renewals.",
  "gunum.renew.note":
    "None lapses silently — each stays open as Critical in your queue; it cannot be suppressed.",
  "gunum.renew.link": "Go to renewals",
  // (5) Conversion
  "gunum.conv.title": "Conversion",
  "gunum.conv.acceptRate": "accept rate",
  "gunum.conv.realized": "realized (accepted/sent)",
  "gunum.conv.mix": "Offer mix",
  "gunum.conv.motor": "Motor",
  "gunum.conv.health": "Health / TSS",
  "gunum.conv.other": "Other",
  "gunum.conv.stageB": "Stage B — prediction is intentionally absent; realized only.",
  "gunum.conv.empty": "No offers sent this period.",
  "gunum.conv.link": "Go to recommendations",
  // (6) Trust & compliance strip
  "gunum.trust.title": "Trust & compliance",
  "gunum.trust.suppressedLabel": "items suppressed this period",
  "gunum.trust.suppressedNote": "no-spam proof — what we held back is on record too.",
  "gunum.trust.careHoldLabel": "households on care-hold",
  "gunum.trust.careHoldNote": "A CARE hold — selling goes quiet for these households.",
  "gunum.trust.framing": "The ones we don't call are part of our work too.",
  "gunum.trust.empty": "Nothing suppressed this period; no household is on care-hold.",
  "gunum.trust.link": "Go to queue",
  // Renewals surface — the renewal cadence line (T-45 → Expired)
  "renewals.heading": "Renewals",
  "renewals.subtitle":
    "The active renewal pipeline in your book, by cadence stage. Current state only; no forecast.",
  "renewals.loading": "Loading the renewal pipeline…",
  "renewals.error.title": "Couldn't open Renewals",
  "renewals.error.detail": "The renewal pipeline couldn't be read right now.",
  "renewals.error.reassure": "No renewal was lost — you can try again.",
  "renewals.retry": "Try again",
  "renewals.cadence.title": "Renewal cadence line",
  "renewals.stage.t45": "T-45",
  "renewals.stage.t30": "T-30",
  "renewals.stage.t15": "T-15",
  "renewals.stage.t7": "T-7",
  "renewals.stage.expired": "Expired",
  "renewals.total": "active renewals",
  "renewals.note":
    "None lapses silently — each stays open as Critical in your queue; it cannot be suppressed.",
  "renewals.duty.title": "Lapsed uninsured — 24h duty of care",
  "renewals.duty.desc":
    "A renewal lapsed within the last 24 hours and the asset has no other active policy — uninsured. This falls under the 24-hour duty of care; it stays open as Critical in your queue.",
  "renewals.list.title": "Upcoming renewals",
  "renewals.list.loading": "Loading renewals…",
  "renewals.list.error": "The renewals list couldn't be read right now.",
  "renewals.list.empty": "No upcoming renewals",
  "renewals.list.more": "Load more",
  "renewals.empty.title": "No upcoming renewals",
  "renewals.empty.desc":
    "There's no active renewal cadence in your book. New renewals appear here as they open.",
  "notifications.heading": "Notifications",
  "notifications.subtitle": "Operational signals awaiting you — critical ones first. No marketing.",
  "notifications.loading": "Loading notifications…",
  "notifications.error.title": "Couldn't open Notifications",
  "notifications.error.detail": "The notification feed couldn't be read right now.",
  "notifications.error.reassure": "No signal was lost — you can try again.",
  "notifications.retry": "Try again",
  "notifications.empty.title": "No notifications — you're all caught up",
  "notifications.empty.desc": "Nothing is pending. New signals appear here as they arrive.",
  "notifications.markAll": "Mark all as read",
  "notifications.filtered":
    "notifications are hidden by your “critical only” preference. Change it in Account & settings.",
  "notifications.markRead": "Mark read",
  "notifications.markUnread": "Mark unread",
  "notifications.unread": "Unread",
  "notifications.critical": "Critical",
  "notifications.group.critical": "Critical",
  "notifications.group.normal": "Notifications",
  "notifications.type.APPROVAL": "Approval awaiting you",
  "notifications.type.SLA_RISK": "SLA at risk",
  "notifications.type.SLA_BREACH": "SLA breach",
  "notifications.type.PAID_NOT_ISSUED": "Paid, not issued",
  "notifications.type.CUSTOMER_RESPONSE": "Customer responded",
  "notifications.type.HOUSEHOLD_ASSIGNED": "New household assigned",
  "notifications.type.RENEWAL_FORCED_HIGH": "Renewal T-7 (high priority)",
  "settings.heading": "Account & Settings",
  "settings.subtitle": "Your personal preferences — settings about you.",
  "settings.loading": "Loading settings…",
  "settings.error.title": "Couldn't load settings",
  "settings.error.detail": "Your preferences couldn't be fetched. Please try again.",
  "settings.retry": "Try again",
  "settings.save": "Save",
  "settings.saving": "Saving…",
  "settings.saved": "Saved.",
  "settings.profile.title": "Profile",
  "settings.profile.name": "Name",
  "settings.profile.role": "Role",
  "settings.profile.email": "Email",
  "settings.profile.governed":
    "Name and role are governed by administration; they can't be edited here.",
  "settings.role.advisor": "Advisor",
  "settings.role.manager": "Team lead",
  "settings.role.admin": "Administrator",
  "settings.prefs.title": "Preferences",
  "settings.prefs.locale": "Language",
  "settings.prefs.locale.hint": "Your choice applies immediately and persists when saved.",
  "settings.prefs.notifications": "Notifications",
  "settings.prefs.criticalOnly": "Critical notifications only",
  "settings.prefs.criticalOnly.hint": "When on, normal-priority notifications are hidden.",
  "settings.prefs.accessibility": "Accessibility",
  "settings.a11y.reducedMotion": "Reduce motion",
  "settings.a11y.highContrast": "High contrast",
  "settings.a11y.fontScale": "Text size",
  "settings.a11y.fontScale.normal": "Normal",
  "settings.a11y.fontScale.large": "Large",
  "settings.scope.title": "Scope",
  "settings.scope.default": "Default landing scope",
  "settings.scope.own": "Own",
  "settings.scope.team": "Team",
  "settings.scope.hint":
    "Your choice is saved, but screens currently derive scope from your grant, so this does not change what you see yet. It takes effect once the reads accept a scope parameter.",
  "settings.security.title": "Security",
  "settings.security.desc":
    "Two-factor, passkeys, sessions and devices are managed in the account console.",
  "settings.security.open": "Open account console",
  "settings.security.note":
    "The account console link isn't configured in this environment. Contact your administrator for security settings.",
  "settings.media.title": "Photo & signature",
  "settings.media.soon": "Coming soon",
  "settings.media.desc":
    "Your profile photo and signature are stored encrypted; only you can access them.",
  "settings.media.photo": "Profile photo",
  "settings.media.signature": "Signature",
  "settings.media.upload": "Upload",
  "settings.media.replace": "Replace",
  "settings.media.remove": "Remove",
  "settings.media.error": "Upload failed. PNG, JPEG or WEBP; 2 MB max.",
};

// The merged dictionary the console's I18nProvider feeds the foundation machinery:
// base chrome strings + the console's surface strings (the console's app.title wins).
export const dictionaries = {
  tr: { ...baseTr, ...tr },
  en: { ...baseEn, ...en },
} as const;
